export enum ComponentSettingKey {
  PromptDataSource = 'prompt-data-source',
  PromptDataTitle = 'prompt-data-title',
  PromptDataDescription = 'prompt-data-description',
  PromptDataPlaceholder = 'prompt-data-placeholder',
  PromptDataSortBy = 'prompt-data-sort-by',
  PromptDataSortType = 'prompt-data-sort-type',
  PromptDataFilter = 'prompt-data-filter',
  PromptDesignBackgroundColor = 'prompt-design-background-color',
  PromptDesignBackgroundColorSolid = 'prompt-design-background-color-solid',
  PromptDesignBackgroundColorStartGradient = 'prompt-design-background-color-start-gradient',
  PromptDesignBackgroundColorEndGradient = 'prompt-design-background-color-end-gradient',
  PromptDesignBackgroundColorGradientDirection = 'prompt-design-background-color-gradient-direction',
  PromptDesignButtonColorVariantSolid = 'prompt-design-button-color-variant-solid',
  PromptDesignButtonColorVariantStartGradient = 'prompt-design-button-color-variant-start-gradient',
  PromptDesignButtonColorVariantEndGradient = 'prompt-design-button-color-variant-end-gradient',
  PromptDesignButtonColorVariantGradientDirection = 'prompt-design-button-color-variant-gradient-direction',
  PromptDesignButtonColorVariant = 'prompt-design-button-color-variant',
  PromptDesignScheme = 'prompt-design-scheme',
  PromptDesignGroupColor = 'prompt-design-group-color',
  PromptDesignDividerColor = 'prompt-design-divider-color',
  PromptDesignDividerColorSolid = 'prompt-design-divider-color-solid',
  PromptDesignDividerColorStartGradient = 'prompt-design-divider-color-start-gradient',
  PromptDesignDividerColorEndGradient = 'prompt-design-divider-color-end-gradient',
  PromptDesignDividerColorGradientDirection = 'prompt-design-divider-color-gradient-direction',
  PromptDesignPlaceholderColor = 'prompt-design-placeholder-color',
  PromptDesignTypography = 'prompt-design-typography',
  PromptDesignPlaceholderColorStartGradient = 'prompt-design-placeholder-color-start-gradient',
  PromptDesignPlaceholderColorEndGradient = 'prompt-design-placeholder-color-end-gradient',
  PromptDesignPlaceholderColorGradientDirection = 'prompt-design-placeholder-color-gradient-direction',
  PromptDesignPlaceholderTypography = 'prompt-design-placeholder-typography',
  PromptDesignSuggestionTypography = 'prompt-design-suggestion-typography',
  PromptDesignSuggestionPadding = 'prompt-design-suggestion-padding',
  PromptDesignShuffleButtonPadding = 'prompt-design-shuffle-button-padding',
  PromptDesignPlaceholderColorSolid = 'prompt-design-placeholder-color-solid',
  PromptDesignWidth = 'prompt-design-width',
  PromptDesignHAlign = 'prompt-design-h-align',
  PromptDesignChipsAlignment = 'prompt-design-chips-alignment',
  PromptDesignChipColor = 'prompt-design-chip-color',
  PromptDesignChipColorSolid = 'prompt-design-chip-color-solid',
  PromptDesignChipColorStartGradient = 'prompt-design-chip-color-start-gradient',
  PromptDesignChipColorEndGradient = 'prompt-design-chip-color-end-gradient',
  PromptDesignChipColorGradientDirection = 'prompt-design-chip-color-gradient-direction',
  PromptDesignMargin = 'prompt-design-margin',
  PromptDesignChipsGap = 'prompt-design-chips-gap',
  PromptDesignBorderThickness = 'prompt-design-border-thickness',
  PromptDesignBorderColor = 'prompt-design-border-color',
  PromptDesignBorderColorSolid = 'prompt-design-border-color-solid',
  PromptDesignElevation = 'prompt-design-elevation',
  PromptDesignCornerRadius = 'prompt-design-corner-radius',
  PromptDesignButtonCornerRadius = 'prompt-design-button-corner-radius',
  PromptDesignNumberDefaultItems = 'prompt-design-number-default-items',
  PromptDesignHoverEffectVariant = 'prompt-design-hover-effect-variant',
  PromptActionOnButtonClick = 'prompt-action-on-button-click',
  PromptActionOnImproveAiClick = 'prompt-action-on-improve-ai-click',
  PromptBehaviorAcceptedFiles = 'prompt-behavior-accepted-files',
  PromptBehaviorMaxSize = 'prompt-behavior-max-size',
  PromptBehaviorMaxFiles = 'prompt-behavior-max-files',
  PromptBehaviorColorSelection = 'prompt-behavior-color-selection',
  PromptBehaviorFileSelection = 'prompt-behavior-file-selection',
  PromptBehaviorFontSelection = 'prompt-behavior-font-selection',

  CalendarDataSource = 'calendar-data-source',
  CalendarDataTitle = 'calendar-data-title',
  CalendarDataStartDate = 'calendar-data-start-date',
  CalendarDataEndDate = 'calendar-data-end-date',
  CalendarDataColor = 'calendar-data-color',
  CalendarDataFilter = 'calendar-data-filter',
  CalendarDataSetLimit = 'calendar-data-set-limit',
  CalendarDataSortBy = 'calendar-data-sort-by',
  CalendarDataSortType = 'calendar-data-sort-type',
  CalendarDesignCompHAlign = 'calendar-design-comp-h-align',
  CalendarDesignTypography = 'calendar-design-typography',
  CalendarDesignTitleTypography = 'calendar-design-title-typography',
  CalendarDesignContentTypography = 'calendar-design-content-typography',
  CalendarDesignDateTypography = 'calendar-design-date-typography',
  CalendarDesignScheme = 'calendar-design-scheme',
  CalendarDesignBackgroundColor = 'calendar-design-background-color',
  CalendarDesignCornerRadius = 'calendar-design-corner-radius',
  CalendarDesignWidth = 'calendar-design-width',
  CalendarDesignMargin = 'calendar-design-margin',
  CalendarDesignPadding = 'calendar-design-padding',
  CalendarDesignFilterMargin = 'calendar-design-filter-margin',
  CalendarDesignElevation = 'calendar-design-elevation',
  CalendarActionOnClick = 'calendar-action-on-click',
  CalendarActionAddEvent = 'calendar-action-add-event',
  CalendarBehaviorDefaultView = 'calendar-behavior-default-view',
  CalendarBehaviorAutoFitDay = 'calendar-behavior-auto-fit-day',
  CalendarBehaviorUserFilter = 'calendar-behavior-user-filter',
  CalendarDesignFilterBgColor = 'calendar-design-filter-bg-color',
  CalendarDesignFilterChipColor = 'calendar-design-filter-chip-color',
  CalendarDesignFilterCornerRadius = 'calendar-design-filter-corner-radius',

  TimelineDataSource = 'timeline-data-source',
  TimelineDataTitle = 'timeline-data-title',
  TimelineDataContent = 'timeline-data-content',
  TimelineDataDate = 'timeline-data-date',
  TimelineDataIcon = 'timeline-data-icon',
  TimelineDataGroupBy = 'timeline-data-group-by',
  TimelineDesignTypography = 'timeline-design-typography',
  TimelineDesignGroupTitleTypography = 'timeline-design-group-title-typography',
  TimelineDesignTitleTypography = 'timeline-design-title-typography',
  TimelineDesignContentTypography = 'timeline-design-content-typography',
  TimelineDesignDateTypography = 'timeline-design-date-typography',
  TimelineDesignOrientation = 'timeline-design-orientation',
  TimelineDesignIconColor = 'timeline-design-icon-color',
  TimelineDesignIconBackgroundColorVariant = 'timeline-design-icon-background-color-variant',
  TimelineDesignTimelineLineColor = 'timeline-design-timeline-line-color',
  TimelineDesignScheme = 'timeline-design-scheme',
  TimelineDesignIconColorVariant = 'timeline-design-icon-color-variant',
  TimelineDesignIconColorCustom = 'timeline-design-icon-color-custom',
  TimelineDesignIconColorColumn = 'timeline-design-icon-color-column',
  TimelineDesignMargin = 'timeline-design-margin',
  TimelineDesignItemGap = 'timeline-design-item-gap',
  TimelineDesignTitleLines = 'timeline-design-title-lines',
  TimelineDesignContentLines = 'timeline-design-content-lines',
  TimelineDesignCompHAlign = 'timeline-design-comp-h-align',
  TimelineDesignWidth = 'timeline-design-width',
  TimelineDesignNumItems = 'timeline-design-num-items',
  TimelineDesignPagination = 'timeline-design-pagination',
  TimelineDesignPaginationAlignment = 'timeline-design-pagination-alignment',
  TimelineDesignHoverEffect = 'timeline-design-hover-effect',
  TimelineActionItemClick = 'timeline-action-item-click',
  TimelineDataSortBy = 'timeline-data-sort-by',
  TimelineDataSortType = 'timeline-data-sort-type',
  TimelineDataFilter = 'timeline-data-filter',
  TimelineDataSetLimit = 'timeline-data-set-limit',
  TimelineDesignTitleColor = 'timeline-design-title-color',
  TimelineDesignTitleColorSolid = 'timeline-design-title-color-solid',
  TimelineDesignTitleColorStartGradient = 'timeline-design-title-color-start-gradient',
  TimelineDesignTitleColorEndGradient = 'timeline-design-title-color-end-gradient',
  TimelineDesignTitleColorGradientDirection = 'timeline-design-title-color-gradient-direction',
  TimelineDesignContentColor = 'timeline-design-content-color',
  TimelineDesignContentColorSolid = 'timeline-design-content-color-solid',
  TimelineDesignContentColorStartGradient = 'timeline-design-content-color-start-gradient',
  TimelineDesignContentColorEndGradient = 'timeline-design-content-color-end-gradient',
  TimelineDesignContentColorGradientDirection = 'timeline-design-content-color-gradient-direction',
  TimelineDesignDateColor = 'timeline-design-date-color',
  TimelineDesignDateColorSolid = 'timeline-design-date-color-solid',
  TimelineDesignDateColorStartGradient = 'timeline-design-date-color-start-gradient',
  TimelineDesignDateColorEndGradient = 'timeline-design-date-color-end-gradient',
  TimelineDesignDateColorGradientDirection = 'timeline-design-date-color-gradient-direction',
  TimelineDesignGroupTitleColor = 'timeline-design-group-title-color',
  TimelineDesignGroupTitleColorSolid = 'timeline-design-group-title-color-solid',
  TimelineDesignGroupTitleColorStartGradient = 'timeline-design-group-title-color-start-gradient',
  TimelineDesignGroupTitleColorEndGradient = 'timeline-design-group-title-color-end-gradient',
  TimelineDesignGroupTitleColorGradientDirection = 'timeline-design-group-title-color-gradient-direction',

  ShoppingCartDataSource = 'shopping-cart-data-source',
  ShoppingCartDataProductName = 'shopping-cart-data-product-name',
  ShoppingCartDataProductImage = 'shopping-cart-data-product-image',
  ShoppingCartDataProductInfo = 'shopping-cart-data-product-info',
  ShoppingCartDataProductPrice = 'shopping-cart-data-product-price',
  ShoppingCartDataProductQuantity = 'shopping-cart-data-product-quantity',
  ShoppingCartDataProductStockStatus = 'shopping-cart-data-product-stock-status',
  ShoppingCartDataFilter = 'shopping-cart-data-filter',
  ShoppingCartDataSortBy = 'shopping-cart-data-sort-by',
  ShoppingCartDataSortType = 'shopping-cart-data-sort-type',
  ShoppingCartDataCompTitle = 'shopping-cart-data-comp-title',
  ShoppingCartDesignBgColor = 'shopping-cart-design-bg-color',
  ShoppingCartDesignSummaryBgColor = 'shopping-cart-design-summary-bg-color',
  ShoppingCartDesignPrimaryButtonColor = 'shopping-cart-design-primary-button-color',
  ShoppingCartDesignSecondaryButtonColor = 'shopping-cart-design-secondary-button-color',
  ShoppingCartDesignCornerRadius = 'shopping-cart-design-corner-radius',
  ShoppingCartDesignWidth = 'shopping-cart-design-width',
  ShoppingCartDesignImageWidth = 'shopping-cart-design-image-width',
  ShoppingCartDesignImageRatio = 'shopping-cart-design-image-ratio',
  ShoppingCartDesignImageRadius = 'shopping-cart-design-image-radius',
  ShoppingCartDesignButtonRadius = 'shopping-cart-design-button-radius',
  ShoppingCartDesignCompHAlign = 'shopping-cart-design-comp-h-align',
  ShoppingCartDesignCompTitleAlign = 'shopping-cart-design-comp-title-align',
  ShoppingCartDesignMargin = 'shopping-cart-design-margin',
  ShoppingCartDesignCompTitleMargin = 'shopping-cart-design-comp-title-margin',
  ShoppingCartDesignTypography = 'shopping-cart-design-typography',
  ShoppingCartDesignHoverEffect = 'shopping-cart-design-hover-effect',
  ShoppingCartDesignTitleTypography = 'shopping-cart-design-title-typography',
  ShoppingCartDesignInfoTypography = 'shopping-cart-design-info-typography',
  ShoppingCartDesignCompTitleTypography = 'shopping-cart-design-comp-title-typography',
  ShoppingCartActionItemClick = 'shopping-cart-action-item-click',
  ShoppingCartActionQtyIncrement = 'shopping-cart-action-qty-increment',
  ShoppingCartActionQtyDecrement = 'shopping-cart-action-qty-decrement',
  ShoppingCartActionRemoveItem = 'shopping-cart-action-remove-item',
  ShoppingCartActionOnProceed = 'shopping-cart-action-on-proceed',
  ShoppingCartActionOnBack = 'shopping-cart-action-on-back',
  ShoppingCartBehaviorAllowQtyChange = 'shopping-cart-behavior-allow-qty-change',
  ShoppingCartBehaviorAllowRemoveItem = 'shopping-cart-behavior-allow-remove-item',

  FormDataSource = 'form-data-source',
  FormDataCompTitle = 'form-data-comp-title',
  FormDesignScheme = 'form-design-scheme',
  FormDesignWidth = 'form-design-width',
  FormDesignHAlign = 'form-design-h-align',
  FormDesignPadding = 'form-design-padding',
  FormDesignMargin = 'form-design-margin',
  FormDesignFieldMargin = 'form-design-field-margin',
  FormDesignTitleColor = 'form-design-title-color',
  FormDesignTitleColorSolid = 'form-design-title-color-solid',
  FormDesignTitleColorStartGradient = 'form-design-title-color-start-gradient',
  FormDesignTitleColorEndGradient = 'form-design-title-color-end-gradient',
  FormDesignTitleColorGradientDirection = 'form-design-title-color-gradient-direction',
  FormDesignLabelColor = 'form-design-label-color',
  FormDesignLabelColorSolid = 'form-design-label-color-solid',
  FormDesignLabelColorStartGradient = 'form-design-label-color-start-gradient',
  FormDesignLabelColorEndGradient = 'form-design-label-color-end-gradient',
  FormDesignLabelColorGradientDirection = 'form-design-label-color-gradient-direction',
  FormDesignCompTitleMargin = 'form-design-comp-title-margin',
  FormDesignFieldHelpTextColor = 'form-design-field-help-text-color',
  FormDesignCompTitleAlign = 'form-design-comp-title-align',
  FormDesignTypography = 'form-design-typography',
  FormDesignGroupColor = 'form-design-group-color',
  FormDesignLabelTypography = 'form-design-label-typography',
  FormDesignInputTypography = 'form-design-input-typography',
  FormDesignHelpTypography = 'form-design-help-typography',
  FormDesignCompTitleTypography = 'form-design-comp-title-typography',
  FormDesignFieldShape = 'form-design-field-shape',
  FormDesignFieldBgColor = 'form-design-field-bg-color',
  FormDesignFieldOutlineColor = 'form-design-field-outline-color',
  FormDesignFieldTextColor = 'form-design-field-text-color',
  FormActionSubmit = 'form-action-submit',

  LoginFormDesignScheme = 'login-form-design-scheme',
  LoginFormDesignGroupColor = 'login-form-design-group-color',
  LoginFormDesignTitleColor = 'login-form-design-title-color',
  LoginFormDesignTitleColorSolid = 'login-form-design-title-color-solid',
  LoginFormDesignTitleColorStartGradient = 'login-form-design-title-color-start-gradient',
  LoginFormDesignTitleColorEndGradient = 'login-form-design-title-color-end-gradient',
  LoginFormDesignTitleColorGradientDirection = 'login-form-design-title-color-gradient-direction',
  LoginFormDesignLabelColor = 'login-form-design-label-color',
  LoginFormDesignLabelColorSolid = 'login-form-design-label-color-solid',
  LoginFormDesignLabelColorStartGradient = 'login-form-design-label-color-start-gradient',
  LoginFormDesignLabelColorEndGradient = 'login-form-design-label-color-end-gradient',
  LoginFormDesignLabelColorGradientDirection = 'login-form-design-label-color-gradient-direction',
  LoginFormDesignFieldBgColor = 'login-form-design-field-bg-color',
  LoginFormDesignFieldOutlineColor = 'login-form-design-field-outline-color',
  LoginFormDesignFieldTextColor = 'login-form-design-field-text-color',
  LoginFormDesignFieldHelpTextColor = 'login-form-design-field-help-text-color',
  LoginFormDesignFieldShape = 'login-form-design-field-shape',
  LoginFormDesignColorVariant = 'login-form-design-color-variant',
  LoginFormDesignVariant = 'login-form-design-variant',
  LoginFormDesignMargin = 'login-form-design-margin',
  LoginFormDesignButtonPadding = 'login-form-design-button-padding',
  LoginFormDesignTypography = 'login-form-design-typography',
  LoginFormDesignTitleTypography = 'login-form-design-title-typography',
  LoginFormDesignLabelTypography = 'login-form-design-label-typography',
  LoginFormDesignInputTypography = 'login-form-design-input-typography',
  LoginFormDesignHelpTypography = 'login-form-design-help-typography',
  LoginFormDesignButtonVariant = 'login-form-design-button-variant',
  LoginFormDesignButtonShape = 'login-form-design-button-shape',
  LoginFormDesignButtonColorVariant = 'login-form-design-button-color-variant',
  LoginFormDesignWidth = 'login-form-design-width',
  LoginFormDesignHAlign = 'login-form-design-h-align',
  LoginFormDesignButtonSize = 'login-form-design-button-size',
  LoginFormActionOnLogin = 'login-form-action-on-login',
  LoginFormActionOnLogout = 'login-form-action-on-logout',
  LoginFormBehaviorRedirect = 'login-form-behavior-redirect',

  SectionDesignShape = 'section-design-shape',
  SectionDesignBgColor = 'section-design-bg-color',
  SectionDesignBgScheme = 'section-design-bg-scheme',
  SectionDesignLayout = 'section-design-layout',
  SectionDesignBgColorVariant = 'section-design-bg-color-variant',
  SectionDesignBgOverlayOpacity = 'section-design-bg-overlay-opacity',
  SectionDesignBackgroundImage = 'section-design-background-image',
  SectionDesignBackgroundColor = 'section-design-background-color',
  SectionDesignForegroundColor = 'section-design-foreground-color',
  SectionDesignBackground = 'section-design-background',
  SectionDesignPadding = 'section-design-padding',
  SectionDesignMargin = 'section-design-margin',
  SectionDesignOverlay = 'section-design-overlay',
  SectionDesignOverlayColor = 'section-design-overlay-color',
  SectionDesignOverlayOpacity = 'section-design-overlay-opacity',
  SectionDesignOverlayTextColor = 'section-design-overlay-text-color',
  SectionDesignOrientation = 'section-design-orientation',
  SectionDesignReverseOrder = 'section-design-reverse-order',
  SectionDesignGap = 'section-design-gap',
  SectionDesignHAlign = 'section-design-h-align',
  SectionDesignVAlign = 'section-design-v-align',
  SectionDesignHorizontalAlign = 'section-design-horizontal-align',
  SectionDesignWidth = 'section-design-width',
  SectionDesignWidthMode = 'section-design-width-mode',
  SectionDesignWidthPreset = 'section-design-width-preset',
  SectionDesignHeight = 'section-design-height',
  SectionDesignHeightMode = 'section-design-height-mode',
  SectionDesignMaxItems = 'section-design-max-items',
  SectionDesignSameHeight = 'section-design-same-height',
  SectionDesignBorder = 'section-design-border',
  SectionDesignBorderWidth = 'section-design-border-width',
  SectionDesignBorderColor = 'section-design-border-color',
  SectionDesignBorderStyle = 'section-design-border-style',
  SectionDesignVariant = 'section-design-variant',
  SectionDesignStickyPosition = 'section-design-sticky-position',
  SectionDesignStickyOffset = 'section-design-sticky-offset',
  SectionDesignElevation = 'section-design-elevation',
  SectionDesignHoverEffect = 'section-design-hover-effect',

  // Columns & Column Item
  ColumnDesignScheme = 'column-design-scheme',
  ColumnDesignCount = 'column-design-count',
  ColumnDesignWidth = 'column-design-width',
  ColumnItemDesignShape = 'column-item-design-shape',
  ColumnItemDesignBgColor = 'column-item-design-bg-color',
  ColumnItemDesignBgScheme = 'column-item-design-bg-scheme',
  ColumnItemDesignBgColorVariant = 'column-item-design-bg-color-variant',
  ColumnItemDesignBackgroundImage = 'column-item-design-background-image',
  ColumnItemDesignBackgroundColor = 'column-item-design-background-color',
  ColumnItemDesignForegroundColor = 'column-item-design-foreground-color',
  ColumnItemDesignPadding = 'column-item-design-padding',
  ColumnItemDesignMargin = 'column-item-design-margin',
  ColumnItemDesignOverlay = 'column-item-design-overlay',
  ColumnItemDesignOverlayColor = 'column-item-design-overlay-color',
  ColumnItemDesignOverlayOpacity = 'column-item-design-overlay-opacity',
  ColumnItemDesignOverlayTextColor = 'column-item-design-overlay-text-color',
  ColumnItemDesignOrientation = 'column-item-design-orientation',
  ColumnItemDesignGap = 'column-item-design-gap',
  ColumnItemDesignHAlign = 'column-item-design-h-align',
  ColumnItemDesignVAlign = 'column-item-design-v-align',
  ColumnItemDesignWidth = 'column-item-design-width',

  TabsData = 'tabs-data',
  TabsDataShowIcon = 'tabs-data-show-icon',
  TabsDataShowLabel = 'tabs-data-show-label',
  TabsDesignBgColor = 'tabs-design-bg-color',
  TabsDesignVariant = 'tabs-design-variant',
  TabsDesignHoverEffect = 'tabs-design-hover-effect',
  TabsDesignWidth = 'tabs-design-width',
  TabsDesignAlign = 'tabs-design-align',
  TabsDesignContentAlign = 'tabs-design-content-align',
  TabsDesignContentShadow = 'tabs-design-content-shadow',
  TabsDesignNavDisplay = 'tabs-design-nav-display',
  TabsDesignOrientation = 'tabs-design-orientation',
  TabsDesignMargin = 'tabs-design-margin',
  TabsDesignPadding = 'tabs-design-padding',
  TabsDesignItemPadding = 'tabs-design-item-padding',
  TabsDesignContentPadding = 'tabs-design-content-padding',
  TabsDesignShape = 'tabs-design-shape',

  ButtonDataLabel = 'button-data-label',
  ButtonDataIcon = 'button-data-icon',
  ButtonDataBadge = 'button-data-badge',
  ButtonDesignScheme = 'button-design-scheme',
  ButtonDesignGroupColor = 'button-design-group-color',
  ButtonDesignColorType = 'button-design-color-type',
  ButtonDesignColorTypeSolid = 'button-design-color-type-solid',
  ButtonDesignColorTypeStartGradient = 'button-design-color-type-start-gradient',
  ButtonDesignColorTypeEndGradient = 'button-design-color-type-end-gradient',
  ButtonDesignColorTypeGradientDirection = 'button-design-color-type-gradient-direction',
  ButtonDesignBadgeBackgroundColorType = 'button-design-badge-background-color-type',
  ButtonDesignBadgeBackgroundColorSolid = 'button-design-badge-background-color-solid',
  ButtonDesignBadgeBackgroundColorStartGradient = 'button-design-badge-background-color-start-gradient',
  ButtonDesignBadgeBackgroundColorEndGradient = 'button-design-badge-background-color-end-gradient',
  ButtonDesignBadgeBackgroundColorGradientDirection = 'button-design-badge-background-color-gradient-direction',
  ButtonDesignColorVariant = 'button-design-color-variant',
  ButtonDesignVariant = 'button-design-variant',
  ButtonDesignShape = 'button-design-shape',
  ButtonDesignIconPosition = 'button-design-icon-position',
  ButtonDesignWidth = 'button-design-width',
  ButtonDesignFit = 'button-design-fit',
  ButtonDesignFullWidth = 'button-design-full-width',
  ButtonDesignSize = 'button-design-size',
  ButtonDesignHAlign = 'button-design-h-align',
  ButtonDesignPadding = 'button-design-padding',
  ButtonDesignMargin = 'button-design-margin',
  ButtonDesignBadgePadding = 'button-design-badge-padding',
  ButtonDesignBadgeTopPosition = 'button-design-badge-top-position',
  ButtonDesignBadgeRightPosition = 'button-design-badge-right-position',
  ButtonDesignTypography = 'button-design-typography',
  ButtonDesignHoverEffect = 'button-design-hover-effect',
  ButtonDesignTextColor = 'button-design-text-color',
  ButtonDesignTextColorSolid = 'button-design-text-color-solid',
  ButtonDesignTextColorStartGradient = 'button-design-text-color-start-gradient',
  ButtonDesignTextColorEndGradient = 'button-design-text-color-end-gradient',
  ButtonDesignTextColorGradientDirection = 'button-design-text-color-gradient-direction',
  ButtonDesignBadgeColor = 'button-design-badge-color',
  ButtonDesignBadgeColorSolid = 'button-design-badge-color-solid',
  ButtonDesignBadgeColorStartGradient = 'button-design-badge-color-start-gradient',
  ButtonDesignBadgeColorEndGradient = 'button-design-badge-color-end-gradient',
  ButtonDesignBadgeColorGradientDirection = 'button-design-badge-color-gradient-direction',
  ButtonDesignIconColor = 'button-design-icon-color',
  ButtonDesignIconColorSolid = 'button-design-icon-color-solid',
  ButtonDesignIconColorStartGradient = 'button-design-icon-color-start-gradient',
  ButtonDesignIconColorEndGradient = 'button-design-icon-color-end-gradient',
  ButtonDesignIconColorGradientDirection = 'button-design-icon-color-gradient-direction',
  ButtonActionClick = 'button-action-click',

  IconButtonDataIcon = 'icon-button-data-icon',
  IconButtonDataIconActive = 'icon-button-data-icon-active',
  IconButtonDataBadge = 'icon-button-data-badge',
  IconButtonDataToggle = 'icon-button-data-toggle',
  IconButtonDesignScheme = 'icon-button-design-scheme',
  IconButtonDesignGroupColor = 'icon-button-design-group-color',
  IconButtonDesignHoverEffect = 'icon-button-design-hover-effect',
  IconButtonDesignActiveColor = 'icon-button-design-active-color',
  IconButtonDesignActiveColorSolid = 'icon-button-design-active-color-solid',
  IconButtonDesignInActiveColor = 'icon-button-design-inactive-color',
  IconButtonDesignInActiveColorSolid = 'icon-button-design-inactive-color-solid',
  IconButtonDesignColorVariant = 'icon-button-design-color-variant',
  IconButtonDesignVariant = 'icon-button-design-variant',
  IconButtonDesignIconColorVariant = 'icon-button-design-icon-color-variant',
  IconButtonDesignIconInactiveColor = 'icon-button-design-icon-inactive-color',
  IconButtonDesignToggledVariant = 'icon-button-design-toggled-variant',
  IconButtonDesignShape = 'icon-button-design-shape',
  IconButtonDesignToggle = 'icon-button-design-toggle',
  IconButtonDesignHAlign = 'icon-button-design-h-align',
  IconButtonDesignIconSize = 'icon-button-design-icon-size',
  IconButtonDesignIconWeight = 'icon-button-design-icon-weight',
  IconButtonDesignIconGrade = 'icon-button-design-icon-grade',
  IconButtonDesignMargin = 'icon-button-design-margin',
  IconButtonDesignPadding = 'icon-button-design-padding',
  IconButtonActionClick = 'icon-button-action-click',

  Fab1DesignIcon = 'fab-primary-design-icon',
  Fab1DataActive = 'fab-primary-data-active',
  Fab1DataIcon = 'fab-primary-data-icon',
  Fab1DataLabel = 'fab-primary-data-label',
  Fab1DataBadge = 'fab-primary-data-badge',
  Fab1DesignScheme = 'fab-primary-design-scheme',
  Fab1DesignColorVariant = 'fab-primary-design-color-variant',
  Fab1DesignSize = 'fab-primary-design-size',
  Fab1DesignVariant = 'fab-primary-design-variant',
  Fab1DesignShadow = 'fab-primary-design-shadow',
  Fab1DesignShape = 'fab-primary-design-shape',
  Fab1DesignTypography = 'fab-primary-design-typography',
  Fab1ActionClick = 'fab-primary-action-click',
  Fab2DataActive = 'fab-secondary-data-active',
  Fab2DataIcon = 'fab-secondary-data-icon',
  Fab2DataLabel = 'fab-secondary-data-label',
  Fab2DataBadge = 'fab-secondary-data-badge',
  Fab2DesignScheme = 'fab-secondary-design-scheme',
  Fab2DesignColorVariant = 'fab-secondary-design-color-variant',
  Fab2DesignSize = 'fab-secondary-design-size',
  Fab2DesignVariant = 'fab-secondary-design-variant',
  Fab2DesignShadow = 'fab-secondary-design-shadow',
  Fab2DesignShape = 'fab-secondary-design-shape',
  Fab2DesignTypography = 'fab-secondary-design-typography',
  Fab2ActionClick = 'fab-secondary-action-click',
  FabDesignHAlign = 'fab-design-h-align',
  FabDesignTypography = 'fab-design-typography',
  FabDesignHoverEffect = 'fab-design-hover-effect',

  TextDataValue = 'text-data-value',
  TextDataURL = 'text-data-url',
  TextDesignScheme = 'text-design-scheme',
  TextDesignGroupColor = 'text-design-group-color',
  TextDesignColor = 'text-design-color',
  TextDesignColorSolid = 'text-design-color-solid',
  TextDesignColorStartGradient = 'text-design-color-start-gradient',
  TextDesignColorEndGradient = 'text-design-color-end-gradient',
  TextDesignColorGradientDirection = 'text-design-color-gradient-direction',
  TextDesignWidth = 'text-design-width',
  TextDesignTypography = 'text-design-typography',
  TextDesignPadding = 'text-design-padding',
  TextDesignMargin = 'text-design-margin',
  TextDesignBorder = 'text-design-border',
  TextDesignCompHAlign = 'text-design-comp-h-align',
  TextDesignHAlign = 'text-design-h-align',
  TextDesignBorderWidth = 'text-design-border-width',
  TextDesignBorderColor = 'text-design-border-color',
  TextDesignCornerRadius = 'text-design-corner-radius',
  TextDesignBorderStyle = 'text-design-border-style',
  TextDesignHoverEffect = 'text-design-hover-effect',
  TextActionClick = 'text-action-click',

  RichTextData = 'rich-text-data',
  RichTextDesignWidth = 'rich-text-design-width',
  RichTextDesignHAlign = 'rich-text-design-h-align',
  RichTextDesignMargin = 'rich-text-design-margin',
  RichTextDesignScheme = 'rich-text-design-scheme',
  RichTextDesignGroupTextColor = 'rich-text-design-group-text-color',
  RichTextDesignH1Color = 'rich-text-design-h1-color',
  RichTextDesignH1ColorSolid = 'rich-text-design-h1-color-solid',
  RichTextDesignH1ColorStartGradient = 'rich-text-design-h1-color-start-gradient',
  RichTextDesignH1ColorEndGradient = 'rich-text-design-h1-color-end-gradient',
  RichTextDesignH1ColorGradientDirection = 'rich-text-design-h1-color-gradient-direction',
  RichTextDesignH2Color = 'rich-text-design-h2-color',
  RichTextDesignH2ColorSolid = 'rich-text-design-h2-color-solid',
  RichTextDesignH2ColorStartGradient = 'rich-text-design-h2-color-start-gradient',
  RichTextDesignH2ColorEndGradient = 'rich-text-design-h2-color-end-gradient',
  RichTextDesignH2ColorGradientDirection = 'rich-text-design-h2-color-gradient-direction',
  RichTextDesignH3Color = 'rich-text-design-h3-color',
  RichTextDesignH3ColorSolid = 'rich-text-design-h3-color-solid',
  RichTextDesignH3ColorStartGradient = 'rich-text-design-h3-color-start-gradient',
  RichTextDesignH3ColorEndGradient = 'rich-text-design-h3-color-end-gradient',
  RichTextDesignH3ColorGradientDirection = 'rich-text-design-h3-color-gradient-direction',
  RichTextDesignH4Color = 'rich-text-design-h4-color',
  RichTextDesignH4ColorSolid = 'rich-text-design-h4-color-solid',
  RichTextDesignH4ColorStartGradient = 'rich-text-design-h4-color-start-gradient',
  RichTextDesignH4ColorEndGradient = 'rich-text-design-h4-color-end-gradient',
  RichTextDesignH4ColorGradientDirection = 'rich-text-design-h4-color-gradient-direction',
  RichTextDesignH5Color = 'rich-text-design-h5-color',
  RichTextDesignH5ColorSolid = 'rich-text-design-h5-color-solid',
  RichTextDesignH5ColorStartGradient = 'rich-text-design-h5-color-start-gradient',
  RichTextDesignH5ColorEndGradient = 'rich-text-design-h5-color-end-gradient',
  RichTextDesignH5ColorGradientDirection = 'rich-text-design-h5-color-gradient-direction',
  RichTextDesignH6Color = 'rich-text-design-h6-color',
  RichTextDesignH6ColorSolid = 'rich-text-design-h6-color-solid',
  RichTextDesignH6ColorStartGradient = 'rich-text-design-h6-color-start-gradient',
  RichTextDesignH6ColorEndGradient = 'rich-text-design-h6-color-end-gradient',
  RichTextDesignH6ColorGradientDirection = 'rich-text-design-h6-color-gradient-direction',
  RichTextDesignPColor = 'rich-text-design-p-color',
  RichTextDesignPColorSolid = 'rich-text-design-p-color-solid',
  RichTextDesignPColorStartGradient = 'rich-text-design-p-color-start-gradient',
  RichTextDesignPColorEndGradient = 'rich-text-design-p-color-end-gradient',
  RichTextDesignPColorGradientDirection = 'rich-text-design-p-color-gradient-direction',
  RichTextDesignOlColor = 'rich-text-design-ol-color',
  RichTextDesignOlColorSolid = 'rich-text-design-ol-color-solid',
  RichTextDesignOlColorStartGradient = 'rich-text-design-ol-color-start-gradient',
  RichTextDesignOlColorEndGradient = 'rich-text-design-ol-color-end-gradient',
  RichTextDesignOlColorGradientDirection = 'rich-text-design-ol-color-gradient-direction',
  RichTextDesignUlColor = 'rich-text-design-ul-color',
  RichTextDesignUlColorSolid = 'rich-text-design-ul-color-solid',
  RichTextDesignUlColorStartGradient = 'rich-text-design-ul-color-start-gradient',
  RichTextDesignUlColorEndGradient = 'rich-text-design-ul-color-end-gradient',
  RichTextDesignUlColorGradientDirection = 'rich-text-design-ul-color-gradient-direction',

  ImageDataSrc = 'image-data-src',
  ImageDataTitle = 'image-data-title',
  ImageDataLike = 'image-data-like',
  ImageDataBadge = 'image-data-badge',
  ImageDataTag = 'image-data-tag',
  ImageDesignScheme = 'image-design-scheme',
  ImageDesignWidth = 'image-design-width',
  ImageDesignLikeIcon = 'image-design-like-icon',
  ImageDesignBorder = 'image-design-border',
  ImageDesignBorderColor = 'image-design-border-color',
  ImageDesignBadgeColor = 'image-design-badge-color',
  ImageDesignBackgroundCaption = 'image-design-background-caption',
  ImageDesignComponentTitleColor = 'image-design-component-title-color',
  ImageDesignShape = 'image-design-shape',
  ImageDesignRatio = 'image-design-ratio',
  ImageDesignHAlign = 'image-design-h-align',
  ImageDesignCompTitleAlign = 'image-design-comp-title-align',
  ImageDesignMargin = 'image-design-margin',
  ImageDesignTextLineCaption = 'image-design-text-line-caption',
  ImageDesignTypography = 'image-design-typography',
  ImageDesignCaptionTypography = 'image-design-caption-typography',
  ImageDesignTagTypography = 'image-design-tag-typography',
  ImageDesignHoverEffect = 'image-design-hover-effect',
  ImageActionClick = 'image-action-click',
  ImageActionLikeClick = 'image-action-like-click',

  VideoDataSrc = 'video-data-src',
  VideoDataTitle = 'video-data-title',
  VideoDataCover = 'video-data-cover',
  VideoDesignScheme = 'video-design-scheme',
  VideoDesignColorVariant = 'video-design-color-variant',
  VideoDesignProgress = 'video-design-progress',
  VideoDesignWidth = 'video-design-width',
  VideoDesignShape = 'video-design-shape',
  VideoDesignMargin = 'video-design-margin',
  VideoDesignPadding = 'video-design-padding',
  VideoDesignVolume = 'video-design-volume',
  VideoDesignControls = 'video-design-controls',
  VideoDesignHAlign = 'video-design-h-align',
  VideoDesignRatio = 'video-design-ratio',
  VideoDesignHoverEffect = 'video-design-hover-effect',

  AudioDataSrc = 'audio-data-src',
  AudioDataCover = 'audio-data-cover',
  AudioDataHeader = 'audio-data-header',
  AudioDataSubHeader = 'audio-data-subheader',
  AudioDataText = 'audio-data-text',
  AudioDesignScheme = 'audio-design-scheme',
  AudioDesignColorVariant = 'audio-design-color-variant',
  AudioDesignFgColorVariant = 'audio-design-fg-color-variant',
  AudioDesignOpacity = 'audio-design-opacity',
  AudioDesignWidth = 'audio-design-width',
  AudioDesignPadding = 'audio-design-padding',
  AudioDesignMargin = 'audio-design-margin',
  AudioDesignShape = 'audio-design-shape',
  AudioDesignHAlign = 'audio-design-h-align',
  AudioDesignTypography = 'audio-design-typography',
  AudioDesignHeaderTypography = 'audio-design-header-typography',
  AudioDesignSubheaderTypography = 'audio-design-subheader-typography',
  AudioDesignSupportingTextTypography = 'audio-design-supporting-text-typography',
  AudioDesignTimerTypography = 'audio-design-timer-typography',
  AudioDesignHoverEffect = 'audio-design-hover-effect',

  TableDataSource = 'table-data-source',
  TableDataCompTitle = 'table-data-comp-title',
  TableDataFilter = 'table-data-filter',
  TableDataSortBy = 'table-data-sort-by',
  TableDataSortType = 'table-data-sort-type',
  TableDataItemsPerPage = 'table-data-items-per-page',
  TableDataSetLimit = 'table-data-set-limit',
  TableDesignNumRows = 'table-design-num-rows',
  TableDesignScheme = 'table-design-scheme',
  TableDesignComponentTitleColor = 'table-design-component-title-color',
  TableDesignTitleColor = 'table-design-color-title',
  TableDesignSearchBgColor = 'table-design-search-bg-color',
  TableDesignHeaderFooterColor = 'table-design-header-footer-color',
  TableDesignOddRowColor = 'table-design-odd-row-color',
  TableDesignEvenRowColor = 'table-design-even-row-color',
  TableDesignBorderColor = 'table-design-border-color',
  TableDesignSearchColor = 'table-design-search-color',
  TableDesignSearchColumnFilterColor = 'table-design-search-column-filter-color',
  TableDesignShowPagination = 'table-design-show-pagination',
  TableDesignTextLines = 'table-design-text-lines',
  TableDesignShowColumnToggle = 'table-design-show-column-toggle',
  TableDesignShowGlobalFilter = 'table-design-show-global-filter',
  TableDesignNoDataMessage = 'table-design-no-data-message',
  TableDesignSearchKey = 'table-design-search-key',
  TableDesignColor1 = 'table-design-color-1',
  TableDesignColor2 = 'table-design-color-2',
  TableDesignColor3 = 'table-design-color-3',
  TableDesignHeader = 'table-design-header',
  TableDesignStrippedRow = 'table-design-stripped-row',
  TableDesignTypography = 'table-design-typography',
  TableDesignTitleTypography = 'table-design-title-typography',
  TableDesignRowHeaderTypography = 'table-design-row-header-typography',
  TableDesignRowItemTypography = 'table-design-row-item-typography',
  TableDesignFooterTypography = 'table-design-footer-typography',
  TableDesignVerticalBorder = 'table-design-vertical-border',
  TableDesignHorizontalBorder = 'table-design-horizontal-border',
  TableDesignOutlineBorderWidth = 'table-design-outline-border-width',
  TableDesignRoundedCorner = 'table-design-rounded-corner',
  TableDesignSearchCorner = 'table-design-search-corner',
  TableDesignWidth = 'table-design-width',
  TableDesignSearchWidth = 'table-design-search-width',
  TableDesignComponentHAlign = 'table-design-comp-h-align',
  TableDesignPaginationHAlign = 'table-design-pagination-h-align',
  TableDesignFooterHAlign = 'table-design-footer-h-align',
  TableDesignTitleHAlign = 'table-design-title-h-align',
  TableDesignSearchAlignment = 'table-design-search-alignment',
  TableDesignMargin = 'table-design-margin',
  TableDesignPadding = 'table-design-padding',
  TableDesignSearchMargin = 'table-design-search-margin',
  TableDesignFilterMargin = 'table-design-filter-margin',
  TableDesignTitleMargin = 'table-design-title-margin',
  TableDesignHoverEffect = 'table-design-hover-effect',
  TableActionItemSelection = 'table-action-item-selection',
  TableActionItemClick = 'table-action-item-click',
  TableBehaviorPagination = 'table-behavior-pagination',
  TableBehaviorSorting = 'table-behavior-sorting',
  TableBehaviorRowSelection = 'table-behavior-row-selection',
  TableBehaviorUserFilter = 'table-behavior-user-filter-field',
  TableBehaviorUserSearch = 'table-behavior-user-search',
  TableBehaviorAddButtonShow = 'table-behavior-add-button-show',
  TableBehaviorAddButtonVisibility = 'table-behavior-add-button-visibility',
  TableActionAddButtonClick = 'table-action-add-button-click',
  TableDesignAddButtonPosition = 'table-design-add-button-position',
  TableDesignAddButtonColor = 'table-design-add-button-color',
  TableDesignAddButtonCornerRadius = 'table-design-add-button-corner-radius',

  DataListData = 'data-list-data',
  DataListHeadline = 'data-list-text',
  DataListDesignScheme = 'data-list-design-scheme',
  DataListDesignColor1 = 'data-list-design-color-1',
  DataListDesignTitleColor = 'data-list-design-title-color',
  DataListDesignColor2 = 'data-list-design-color-2',
  DataListDesignVariant = 'data-list-design-variant',
  DataListDesignWidth = 'data-list-design-width',
  DataListDesignHAlign = 'data-list-design-h-align',
  DataListDesignHeadlineAlign = 'data-list-design-headline-align',
  DataListDesignBorderVariant = 'data-list-design-border-variant',
  DataListDesignTitleEnd = 'data-list-design-title-alignment',
  DataListDesignContentEnd = 'data-list-design-content-alignment',
  DataListDesignRoundedCorner = 'data-list-design-rounded-corner',
  DataListDesignMargin = 'data-list-design-margin',
  DataListDesignPadding = 'data-list-design-padding',
  DataListDesignHeadlineMargin = 'data-list-design-headline-margin',
  DataListDesignTypography = 'data-list-design-typography',
  DataListDesignTitleTypography = 'data-list-design-title-typography',
  DataListDesignContentTypography = 'data-list-design-content-typography',
  DataListDesignHoverEffect = 'data-list-design-hover-effect',

  DividerDataText = 'divider-data-text',
  DividerDesignInset = 'divider-design-inset',
  DividerDesignWidth = 'divider-design-width',
  DividerDesignLineThickness = 'divider-design-line-thickness',
  DividerDesignMargin = 'divider-design-margin',
  DividerDesignPadding = 'divider-design-padding',
  DividerDesignTextAlignment = 'divider-design-text-alignment',
  DividerDesignComponentAlignment = 'divider-design-component-alignment',
  DividerDesignTextStyle = 'divider-design-text-style',
  DividerDesignTitleTypography = 'divider-design-title-typography',
  DividerDesignScheme = 'divider-design-scheme',
  DividerDesignColor = 'divider-design-color',
  DividerDesignGroupColor = 'divider-design-group-color',
  DividerDesignColorSolid = 'divider-design-color-solid',
  DividerDesignColorStartGradient = 'divider-design-color-start-gradient',
  DividerDesignColorEndGradient = 'divider-design-color-end-gradient',
  DividerDesignColorGradientDirection = 'divider-design-color-gradient-direction',
  DividerDesignChipColor = 'divider-design-chip-color',

  LinearProgressDataIndeterminate = 'linear-progress-data-indeterminate',
  LinearProgressDataMaxValue = 'linear-progress-data-max-value',
  LinearProgressDataValue = 'linear-progress-data-value',
  LinearProgressDataBuffer = 'linear-progress-data-buffer',
  LinearProgressDataTitle = 'linear-progress-data-title',
  LinearProgressDesignScheme = 'linear-progress-design-scheme',
  LinearProgressDesignValueColor = 'linear-progress-design-value-color',
  LinearProgressDesignValueColorSolid = 'linear-progress-design-value-color-solid',
  LinearProgressDesignValueColorStartGradient = 'linear-progress-design-value-color-start-gradient',
  LinearProgressDesignValueColorEndGradient = 'linear-progress-design-value-color-end-gradient',
  LinearProgressDesignValueColorGradientDirection = 'linear-progress-design-value-color-gradient-direction',
  LinearProgressDesignGroupColor = 'linear-progress-design-group-color',
  LinearProgressDesignLabelColor = 'linear-progress-design-label-color',
  LinearProgressDesignLabelColorSolid = 'linear-progress-design-label-color-solid',
  LinearProgressDesignLabelColorStartGradient = 'linear-progress-design-label-color-start-gradient',
  LinearProgressDesignLabelColorEndGradient = 'linear-progress-design-label-color-end-gradient',
  LinearProgressDesignLabelColorGradientDirection = 'linear-progress-design-label-color-gradient-direction',
  LinearProgressDesignCircleColor = 'linear-progress-design-circle-color',
  LinearProgressDesignCircleColorSolid = 'linear-progress-design-circle-color-solid',
  LinearProgressDesignCircleColorStartGradient = 'linear-progress-design-circle-color-start-gradient',
  LinearProgressDesignCircleColorEndGradient = 'linear-progress-design-circle-color-end-gradient',
  LinearProgressDesignCircleColorGradientDirection = 'linear-progress-design-circle-color-gradient-direction',
  LinearProgressDesignTrackColor = 'linear-progress-design-track-color',
  LinearProgressDesignTrackColorSolid = 'linear-progress-design-track-color-solid',
  LinearProgressDesignTrackColorStartGradient = 'linear-progress-design-track-color-start-gradient',
  LinearProgressDesignTrackColorEndGradient = 'linear-progress-design-track-color-end-gradient',
  LinearProgressDesignTrackColorGradientDirection = 'linear-progress-design-track-color-gradient-direction',
  LinearProgressDesignWidth = 'linear-progress-design-width',
  LinearProgressDesignHeight = 'linear-progress-design-height',
  LinearProgressDesignAlignment = 'linear-progress-design-alignment',
  LinearProgressDesignHeadingAlignment = 'linear-progress-design-heading-alignment',
  LinearProgressValueAlignment = 'linear-progress-value-alignment',
  LinearProgressDesignActiveIndicatorColor = 'linear-progress-design-active-indicator-color',
  LinearProgressDesignCompTitleColor = 'linear-progress-design-comp-title-color',
  LinearProgressDesignMargin = 'linear-progress-design-margin',
  LinearProgressDesignTitleMargin = 'linear-progress-design-title-margin',
  LinearProgressDesignValueMargin = 'linear-progress-design-value-margin',
  LinearProgressDesignTypography = 'linear-progress-design-typography',
  LinearProgressDesignHeadingTypography = 'linear-progress-design-heading-typography',
  LinearProgressDesignValueTypography = 'linear-progress-design-value-typography',

  CircularProgressDataHeading = 'circular-progress-data-heading',
  CircularProgressDataIndeterminate = 'circular-progress-data-indeterminate',
  CircularProgressDataMaxValue = 'circular-progress-data-max-value',
  CircularProgressDataValue = 'circular-progress-data-value',
  CircularProgressDesignScheme = 'circular-progress-design-scheme',
  CircularProgressDesignValueColor = 'circular-progress-design-value-color',
  CircularProgressDesignValueColorSolid = 'circular-progress-design-value-color-solid',
  CircularProgressDesignValueColorStartGradient = 'circular-progress-design-value-color-start-gradient',
  CircularProgressDesignValueColorEndGradient = 'circular-progress-design-value-color-end-gradient',
  CircularProgressDesignValueColorGradientDirection = 'circular-progress-design-value-color-gradient-direction',
  CircularProgressDesignGroupColor = 'circular-progress-design-group-color',
  CircularProgressDesignLabelColor = 'circular-progress-design-label-color',
  CircularProgressDesignLabelColorSolid = 'circular-progress-design-label-color-solid',
  CircularProgressDesignLabelColorStartGradient = 'circular-progress-design-label-color-start-gradient',
  CircularProgressDesignLabelColorEndGradient = 'circular-progress-design-label-color-end-gradient',
  CircularProgressDesignLabelColorGradientDirection = 'circular-progress-design-label-color-gradient-direction',
  CircularProgressDesignCircleColor = 'circular-progress-design-circle-color',
  CircularProgressDesignCircleColorSolid = 'circular-progress-design-circle-color-solid',
  CircularProgressDesignCircleColorStartGradient = 'circular-progress-design-circle-color-start-gradient',
  CircularProgressDesignCircleColorEndGradient = 'circular-progress-design-circle-color-end-gradient',
  CircularProgressDesignCircleColorGradientDirection = 'circular-progress-design-circle-color-gradient-direction',
  CircularProgressDesignShowValue = 'circular-progress-design-show-value',
  CircularProgressDesignSize = 'circular-progress-design-size',
  CircularProgressDesignTypography = 'circular-progress-design-typography',
  CircularProgressDesignLabelTypography = 'circular-progress-design-label-typography',
  CircularProgressDesignHeadingTypography = 'circular-progress-design-heading-typography',
  CircularProgressDesignAlignment = 'circular-progress-design-alignment',
  CircularProgressDesignHeadingAlignment = 'circular-progress-design-heading-alignment',
  CircularProgressDesignActiveIndicatorColor = 'circular-progress-design-active-indicator-color',
  CircularProgressDesignCompTitleColor = 'circular-progress-design-comp-title-color',
  CircularProgressDesignTrackColor = 'circular-progress-design-track-color',
  CircularProgressDesignMargin = 'circular-progress-design-margin',
  CircularProgressDesignHeadingMargin = 'circular-progress-design-heading-margin',

  LocationDataAddress = 'location-data-address',
  LocationDataMarker = 'location-data-marker',
  LocationDataHeader = 'location-data-header',
  LocationDataSubHeader = 'location-data-subheader',
  LocationDataDescription = 'location-data-description',
  LocationDataAvatar = 'location-data-avatar',
  LocationDataImage = 'location-data-image',
  LocationDataMetadata1 = 'location-data-metadata-1',
  LocationDataMetadata2 = 'location-data-metadata-2',
  LocationDataMetadata3 = 'location-data-metadata-3',
  LocationDesignScheme = 'location-design-scheme',
  LocationDesignColorMarker = 'location-design-color-marker',
  LocationDesignWidth = 'location-design-width',
  LocationDesignAlignment = 'location-design-alignment',
  LocationDesignHeight = 'location-design-height',
  LocationDesignShape = 'location-design-shape',
  LocationDesignMargin = 'location-design-margin',
  LocationBehaviorFullscreenControl = 'location-behavior-fullscreen-control',
  LocationBehaviorMapTypeControl = 'location-behavior-map-type-control',
  LocationBehaviorStreetViewControl = 'location-behavior-street-view-control',
  LocationBehaviorZoomControl = 'location-behavior-zoom-control',
  LocationActionOnClick = 'location-action-on-click',
  LocationActionOnDragEnd = 'location-action-on-drag-end',
  LocationBehaviorDraggable = 'location-design-draggable',
  LocationBehaviorZoomLevel = 'location-design-zoom-level',
  LocationBehaviorInfoBubble = 'location-behavior-info-bubble',

  MultiLocationDataSource = 'multi-location-data-source',
  MultiLocationDataFilterableColumns = 'multi-location-data-filterable-columns',
  MultiLocationDataAddress = 'multi-location-data-address',
  MultiLocationDataMarker = 'multi-location-data-marker',
  MultiLocationDataHeader = 'multi-location-data-header',
  MultiLocationDataSubHeader = 'multi-location-data-subheader',
  MultiLocationDataDescription = 'multi-location-data-description',
  MultiLocationDataAvatar = 'multi-location-data-avatar',
  MultiLocationDataImage = 'multi-location-data-image',
  MultiLocationDataMetadata1 = 'multi-location-data-metadata-1',
  MultiLocationDataMetadata2 = 'multi-location-data-metadata-2',
  MultiLocationDataMetadata3 = 'multi-location-data-metadata-3',
  MultiLocationDataNumItems = 'multi-location-data-num-items',
  MultiLocationDataFilter = 'multi-location-data-filter',
  MultiLocationDesignScheme = 'multi-location-design-scheme',
  MultiLocationDesignColorMarker = 'multi-location-design-color-marker',
  MultiLocationDesignWidth = 'multi-location-design-width',
  MultiLocationDesignHeight = 'multi-location-design-height',
  MultiLocationDesignAlignment = 'multi-location-design-alignment',
  MultiLocationDesignCluster = 'multi-location-design-cluster',
  MultiLocationDesignShape = 'multi-location-design-shape',
  MultiLocationDesignMargin = 'multi-location-design-margin',
  MultiLocationDesignHoverEffect = 'multi-location-design-hover-effect',
  MultiLocationBehaviorFullscreenControl = 'multi-location-behavior-fullscreen-control',
  MultiLocationBehaviorMapTypeControl = 'multi-location-behavior-map-type-control',
  MultiLocationBehaviorStreetViewControl = 'multi-location-behavior-street-view-control',
  MultiLocationBehaviorZoomControl = 'multi-location-behavior-zoom-control',
  MultiLocationActionOnClick = 'multi-location-action-on-click',
  MultiLocationActionOnDragEnd = 'multi-location-action-on-drag-end',
  MultiLocationBehaviorDraggable = 'multi-location-design-draggable',
  MultiLocationBehaviorZoomLevel = 'multi-location-design-zoom-level',
  MultiLocationBehaviorInfoBubble = 'multi-location-behavior-info-bubble',
  MultiLocationBehaviorUserFilter = 'multi-location-behavior-user-filter',

  PieChartDataSource = 'pie-chart-data-source',
  PieChartDataSortBy = 'pie-chart-data-sort-by',
  PieChartDataSortType = 'pie-chart-data-sort-type',
  PieChartDataFilter = 'pie-chart-data-filter',
  PieChartDataItemsPerPage = 'pie-chart-data-items-per-page',
  PieChartDataIdColumn = 'pie-chart-data-id-column',
  PieChartDataLabelColumn = 'pie-chart-data-label-column',
  PieChartDataValueColumn = 'pie-chart-data-value-column',
  PieChartDataHeading = 'pie-chart-data-heading',
  PieChartDesignScheme = 'pie-chart-design-scheme',
  PieChartDesignColorSequence = 'pie-chart-design-color-sequence',
  PieChartDesignWidth = 'pie-chart-design-width',
  PieChartDesignAlignment = 'pie-chart-design-alignment',
  PieChartDesignHeadingAlignment = 'pie-chart-design-heading-alignment',
  PieChartDesignComponentMargin = 'pie-chart-design-component-margin',
  PieChartDesignDoughnut = 'pie-chart-design-doughnut',
  PieChartDesignAbbrNumber = 'pie-chart-design-abbr-number',
  PieChartDesignLabel = 'pie-chart-design-label',
  PieChartDesignLegend = 'pie-chart-design-legend',
  PieChartDesignTypography = 'pie-chart-design-typography',
  PieChartDesignHeadingTypography = 'pie-chart-design-heading-typography',
  PieChartDesignHeadingMargin = 'pie-chart-design-heading-margin',

  BarChartDataSource = 'bar-chart-data-source',
  BarChartDataFilter = 'bar-chart-data-filter',
  BarChartDataItemsPerPage = 'bar-chart-data-items-per-page',
  BarChartDataXAxisColumn = 'bar-chart-data-x-axis-column',
  BarChartDataValueColumns = 'bar-chart-data-value-columns',
  BarChartDataHeading = 'bar-chart-data-heading',
  BarChartDataSortBy = 'bar-chart-data-sort-by',
  BarChartDataSortType = 'bar-chart-data-sort-type',
  BarChartDesignColorSequence = 'bar-chart-design-color-sequence',
  BarChartDesignWidth = 'bar-chart-design-width',
  BarChartDesignAlignment = 'bar-chart-design-alignment',
  BarChartDesignHeadingAlignment = 'bar-chart-design-heading-alignment',
  BarChartDesignAbbrNumber = 'bar-chart-design-abbr-number',
  BarChartDesignXAxisLabelSkew = 'bar-chart-design-x-axis-label-skew',
  BarChartDesignYAxisLabelSkew = 'bar-chart-design-y-axis-label-skew',
  BarChartDesignHorizontal = 'bar-chart-design-horizontal',
  BarChartHeadingTypography = 'bar-chart-heading-typography',
  BarChartDesignXAxisTypography = 'bar-chart-design-x-axis-typography',
  BarChartDesignValuesTypography = 'bar-chart-design-values-typography',
  BarChartDesignMultiDataSet = 'bar-chart-design-multi-data-set',
  BarChartDesignStyle = 'bar-chart-design-style',
  BarChartDesignTypography = 'bar-chart-design-typography',
  BarChartDesignHeadingTypography = 'bar-chart-design-heading-typography',
  BarChartDesignLegend = 'bar-chart-design-legend',
  BarChartDesignShowGrid = 'bar-chart-design-show-grid',
  BarChartDesignShowAxis = 'bar-chart-design-show-axis',
  BarChartDesignHeadingMargin = 'bar-chart-design-heading-margin',
  BarChartDesignCompMargin = 'bar-chart-design-comp-margin',
  BarChartDesignLegendGap = 'bar-chart-design-legend-gap',

  ListDataSource = 'list-data-source',

  ListDataTrailingToggleCheckBox = 'list-data-trailing-toggle-check-box',
  ListDataTrailingToggleSwitch = 'list-data-trailing-toggle-switch',
  ListDataTrailingToggleIconButton = 'list-data-trailing-toggle-icon-button',

  ListDataCompTitle = 'list-data-comp-title',
  ListDataMedia = 'list-data-media',
  ListDataBadge = 'list-data-badge',
  ListDataTitle = 'list-data-title',
  ListDataText = 'list-data-supporting-text',
  ListDataText3 = 'list-data-text-3',
  ListDataTrailingType = 'list-data-trailing-type',
  ListDataSelectedActionMenu = 'list-data-selected-action-menu',
  ListDataInteractionComponent = 'list-data-interaction-component',
  ListDataTrailingMenu = 'list-data-trailing-menu',
  ListDataTrailingMetadata = 'list-data-trailing-metadata',
  ListDataTrailingToggle = 'list-data-trailing-toggle',
  ListDataTrailingToggleUserSpec = 'list-data-trailing-toggle-user-spec',
  ListDataTrailingToggleIcon = 'list-data-trailing-toggle-icon',
  ListDataTrailingIconButtonIcon = 'list-data-trailing-icon-button-icon',
  ListDataNumItems = 'list-data-num-items',
  ListDefaultPerPage = 'list-default-per-page',
  ListDataFilter = 'list-data-filter',
  ListDataSortBy = 'list-data-sort-by',
  ListDataSortType = 'list-data-sort-type',
  ListDataGroupBy = 'list-data-group-by',
  ListDesignCompHAlign = 'list-design-comp-h-align',
  ListDesignCompTitleAlign = 'list-design-comp-title-align',
  ListDesignGroupHeaderAlign = 'list-design-group-header-align',
  ListDesignGroupSearchAlign = 'list-design-group-search-align',
  ListDesignWidth = 'list-design-width',
  ListDesignScheme = 'list-design-scheme',
  ListDesignBgColor = 'list-design-bg-color',
  ListDesignItemGap = 'list-design-item-gap',
  ListDesignItemPadding = 'list-design-item-padding',
  ListDesignColorMode = 'list-design-color-mode',
  ListDesignColorToneOrder = 'list-design-color-tone-order',
  ListDesignColorStartPalette = 'list-design-color-start-palette',
  ListDesignItemBgColor = 'list-design-item-bg-color',
  ListDesignSearchBgColor = 'list-design-search-bg-color',
  ListDesignMetadataBgColor = 'list-design-metadata-bg-color',
  ListDesignItemBgOpacity = 'list-design-item-bg-opacity',
  ListDesignItemShowBorder = 'list-design-item-show-border',
  ListDesignCompTitleColor = 'list-design-comp-title-color',
  ListDesignCompTitleColorSolid = 'list-design-comp-title-color-solid',
  ListDesignCompTitleColorStartGradient = 'list-design-comp-title-color-start-gradient',
  ListDesignCompTitleColorEndGradient = 'list-design-comp-title-color-end-gradient',
  ListDesignCompTitleColorGradientDirection = 'list-design-comp-title-color-gradient-direction',
  ListDesignGroupHeaderColor = 'list-design-group-header-color',
  ListDesignGroupHeaderColorSolid = 'list-design-group-header-color-solid',
  ListDesignGroupHeaderColorStartGradient = 'list-design-group-header-color-start-gradient',
  ListDesignGroupHeaderColorEndGradient = 'list-design-group-header-color-end-gradient',
  ListDesignGroupHeaderColorGradientDirection = 'list-design-group-header-color-gradient-direction',
  ListDesignGroupTitleColor = 'list-design-group-title-color',
  ListDesignTitleColor = 'list-design-title-color',
  ListDesignTitleColorSolid = 'list-design-title-color-solid',
  ListDesignTitleColorStartGradient = 'list-design-title-color-start-gradient',
  ListDesignTitleColorEndGradient = 'list-design-title-color-end-gradient',
  ListDesignTitleColorGradientDirection = 'list-design-title-color-gradient-direction',
  ListDesignSupportingTextColor = 'list-design-supporting-text-color',
  ListDesignSupportingTextColorSolid = 'list-design-supporting-text-color-solid',
  ListDesignSupportingTextColorStartGradient = 'list-design-supporting-text-color-start-gradient',
  ListDesignSupportingTextColorEndGradient = 'list-design-supporting-text-color-end-gradient',
  ListDesignSupportingTextColorGradientDirection = 'list-design-supporting-text-color-gradient-direction',
  ListDesignText3Color = 'list-design-text-3-color',
  ListDesignText3ColorSolid = 'list-design-text-3-color-solid',
  ListDesignText3ColorStartGradient = 'list-design-text-3-color-start-gradient',
  ListDesignText3ColorEndGradient = 'list-design-text-3-color-end-gradient',
  ListDesignText3ColorGradientDirection = 'list-design-text-3-color-gradient-direction',
  ListDesignBadgeColor = 'list-design-badge-color',
  ListDesignMediaRatio = 'list-design-media-ratio',
  ListDesignMediaCorner = 'list-design-media-corner',
  ListDesignSearchCorner = 'list-design-search-corner',
  ListDesignIconColorCustom = 'list-design-icon-color-custom',
  ListDesignIconColorVariant = 'list-design-icon-color-variant',
  ListDesignIconColorColumn = 'list-design-icon-color-column',
  ListDesignIconBackgroundColorColumn = 'list-design-icon-background-color-column',
  ListDesignIconBackgroundColorVariant = 'list-design-icon-background-color-variant',
  ListDesignIconSize = 'list-design-icon-size',
  ListDesignImageWidth = 'list-design-image-width',
  ListDesignSearchWidth = 'list-design-search-width',
  ListDesignIconWeight = 'list-design-icon-weight',
  ListDesignIconGrade = 'list-design-icon-grade',
  ListDesignIconVariant = 'list-design-icon-variant',
  ListDesignIconFilled = 'list-design-icon-filled',
  ListDesignRatingIcon = 'list-design-rating-icon',
  ListDesignRatingColorVariant = 'list-design-rating-color-variant',
  ListDesignMultiline = 'list-design-multiline',
  ListDesignDivider = 'list-design-divider',
  ListDesignDividerInset = 'list-design-divider-inset',
  ListDesignOrientation = 'list-design-orientation',
  ListDesignSameHeight = 'list-design-same-height',
  ListDesignHoverEffect = 'list-design-hover-effect',
  ListDesignHoverEffectVariant = 'list-design-hover-effect-variant',
  ListDesignPagination = 'list-design-pagination',
  ListDesignNumRows = 'list-design-num-rows',
  ListDesignNumCols = 'list-design-num-cols',
  ListDesignColumnRow = 'list-design-column-row',
  ListDesignTypography = 'list-design-typography',
  ListDesignLabelTypography = 'list-design-label-typography',
  ListDesignSupportingTextTypography = 'list-design-supporting-text-typography',
  ListDesignText3Typography = 'list-design-text-3-typography',
  ListDesignMetadataTypography = 'list-design-metadata-typography',
  ListDesignHeadlineTypography = 'list-design-headline-typography',
  ListDesignGroupHeaderTypography = 'list-design-group-header-typography',
  ListDesignButton = 'list-design-button',
  ListDesignPaginationAlignment = 'list-design-pagination-align',
  ListDesignButtonVariant = 'list-design-button-variant',
  ListDesignButtonIconPosition = 'list-design-button-icon-position',
  ListDesignAlignment = 'list-design-alignment',
  ListDesignMargin = 'list-design-margin',
  ListDesignColumnMargin = 'list-design-column-margin',
  ListDesignItemMargin = 'list-design-item-margin',
  ListDesignHeadlineMargin = 'list-design-headline-margin',
  ListDesignGroupHeaderMargin = 'list-design-group-header-margin',
  ListDesignSearchMargin = 'list-design-search-margin',
  ListDesignFilterMargin = 'list-design-filter-margin',
  ListDesignSupportingTextLines = 'list-design-supporting-text-lines',
  ListDesignText3Lines = 'list-design-text-3-lines',
  ListDesignTitleLines = 'list-design-title-lines',
  ListDesignShape = 'list-design-shape',
  ListDesignFilterBgColor = 'list-design-filter-bg-color',
  ListDesignFilterChipColor = 'list-design-filter-chip-color',
  ListDesignFilterCornerRadius = 'list-design-filter-corner-radius',
  ListDesignAddButtonCornerRadius = 'list-design-add-button-corner-radius',
  ListDesignAddButtonColor = 'list-design-add-button-color',
  ListItemDesignShape = 'list-item-design-shape',
  ListActionItemClick = 'list-action-item-click',
  ListActionItemSelection = 'list-action-item-selection',
  ListActionButtonClick = 'list-action-button-click',
  ListActionIconButtonClick = 'list-action-icon-button-click-temp',
  ListActionAddButtonClick = 'list-action-add-button-click',
  ListBehaviorUserFilter = 'list-behavior-user-filter',
  ListBehaviorUserFilterPosition = 'list-behavior-user-filter-position',
  ListBehaviorUserSearch = 'list-behavior-user-search',
  ListBehaviorSearchResultsInfo = 'list-behavior-search-results-info',
  ListDataSetLimit = 'list-data-set-limit',
  ListBehaviorAddButtonShow = 'list-behavior-add-button-show',
  ListBehaviorAddButtonPosition = 'list-behavior-add-button-position',
  ListBehaviorAddButtonVisibility = 'list-behavior-add-button-visibility',

  CardDataSource = 'card-data-source',
  CardDataFilterableColumns = 'card-data-filterable-columns',
  CardDataThumbnail = 'card-data-thumbnail',
  CardDataHeader = 'card-data-header',
  CardDataSubHeader = 'card-data-subheader',
  CardDataMedia = 'card-data-media',
  CardDataTitle = 'card-data-title',
  CardDataSubtitle = 'card-data-subtitle',
  CardDataSupportingText = 'card-data-supporting-text',
  CardDataMetadata1 = 'card-data-metadata-1',
  CardDataMetadata2 = 'card-data-metadata-2',
  CardDataTrailingHeaderMenu = 'card-data-trailing-header-menu',
  CardDataTrailingMenu = 'card-data-trailing-menu',
  CardDataActionHelp = 'card-data-action-help',
  CardDataFooter = 'card-data-footer',
  CardDataLeadingAction = 'card-data-leading-action',
  CardDataLeadingActionLabel = 'card-data-leading-action-label',
  CardDataLeadingActionIcon = 'card-data-leading-action-icon',
  CardDataLeadingActionIconPosition = 'card-data-leading-action-icon-position',
  CardDataTrailingAction = 'card-data-trailing-action',
  CardDataTrailingActionLabel = 'card-data-trailing-action-label',
  CardDataTrailingActionIcon = 'card-data-trailing-action-icon',
  CardDataTrailingActionIconPosition = 'card-data-trailing-action-icon-position',
  CardDataNumItems = 'card-data-num-items',
  CardDefaultPerPage = 'card-default-per-page',
  CardDataSortBy = 'card-data-sort-by',
  CardDataSortType = 'card-data-sort-type',
  CardDataFilter = 'card-data-filter',
  CardDataCompTitle = 'card-data-comp-title',
  CardDataGroupBy = 'card-data-group-by',
  CardDesignScheme = 'card-design-scheme',
  CardDesignBgColor = 'card-design-bg-color',
  CardDesignColorGroup = 'card-design-color-group',
  CardDesignColorMode = 'card-design-color-mode',
  CardDesignColorToneOrder = 'card-design-color-tone-order',
  CardDesignColorStartPalette = 'card-design-color-start-palette',
  CardDesignSearchBgColor = 'card-design-search-bg-color',
  CardDesignBgOpacity = 'card-design-bg-opacity',
  CardDesignCompTitleColor = 'card-design-comp-title-color',
  CardDesignGroupHeaderColor = 'card-design-group-header-color',
  CardDesignLeadingButtonScheme = 'card-design-leading-button-scheme',
  CardDesignTrailingButtonScheme = 'card-design-trailing-button-scheme',
  CardDesignGroupHeaderAlign = 'card-design-group-header-align',
  CardDesignHeaderColorVariant = 'card-design-header-color-variant',
  CardDesignSubheaderColorVariant = 'card-design-subheader-color-variant',
  CardDesignTitleColorVariant = 'card-design-title-color-variant',
  CardDesignSubtitleColorVariant = 'card-design-subtitle-color-variant',
  CardDesignSupportingTextColorVariant = 'card-design-supporting-text-color-variant',
  CardDesignShape = 'card-design-shape',
  CardDesignThumbShape = 'card-design-thumb-shape',
  CardDesignMediaShape = 'card-design-media-shape',
  CardDesignLeadingButtonShape = 'card-design-leading-btn-shape',
  CardDesignTrailingButtonShape = 'card-design-trailing-btn-shape',
  CardDesignSearchCorner = 'card-design-search-corner',
  CardDesignVariant = 'card-design-variant',
  CardDesignOutlinedNoBorder = 'card-design-no-border',
  CardDesignOutlinedNoHoverBg = 'card-design-no-hover-bg',
  CardDesignOutlinedNoPadding = 'card-design-no-padding',
  CardDesignLeadingButtonVariant = 'card-design-leading-button-variant',
  CardDesignTrailingButtonVariant = 'card-design-trailing-button-variant',
  CardDesignNumCols = 'card-design-num-cols',
  CardDesignNumRows = 'card-design-num-rows',
  CardDesignPagination = 'card-design-pagination',
  CardDesignColumnRow = 'card-design-column-row',
  CardDesignItemGap = 'card-design-item-gap',
  CardDesignItemPadding = 'card-design-item-padding',
  CardDesignSameHeight = 'card-design-same-height',
  CardDesignIconVariant = 'card-design-icon-variant',
  CardDesignIconBackgroundColorVariant = 'card-design-icon-background-color-variant',
  CardDesignIconColorFilled = 'card-design-icon-color-filled',
  CardDesignIconColorCustom = 'card-design-icon-color-custom',
  CardDesignIconBackgroundColorColumn = 'card-design-icon-background-color-column',
  CardDesignIconColorColumn = 'card-design-icon-color-column',
  CardDesignIconColorVariant = 'card-design-icon-color-variant',
  CardDesignMediaIconVariant = 'card-design-media-icon-variant',
  CardDesignMediaIconBackgroundColorVariant = 'card-design-media-icon-background-color-variant',
  CardDesignMediaIconColorFilled = 'card-design-media-icon-color-filled',
  CardDesignMediaIconColorCustom = 'card-design-media-icon-color-custom',
  CardDesignMediaIconColorVariant = 'card-design-media-icon-color-variant',
  CardDesignMetadataColorVariant = 'card-design-metadata-color-variant',
  CardDesignMediaIconBackgroundColorColumn = 'card-design-media-icon-background-color-column',
  CardDesignMediaIconColorColumn = 'card-design-media-icon-color-column',
  CardDesignMediaIconSize = 'card-design-media-icon-size',
  CardDesignMediaIconWeight = 'card-design-media-icon-weight',
  CardDesignMediaIconGrade = 'card-design-media-icon-grade',
  CardDesignOrientation = 'card-design-orientation',
  CardDesignFooterButtonOrientation = 'card-design-footer-button-orientation',
  CardDesignSpacingGroup = 'card-design-spacing-group',
  CardDesignMargin = 'card-design-margin',
  CardDesignPadding = 'card-design-padding',
  CardDesignGroupHeaderMargin = 'card-design-group-header-margin',
  CardDesignFooterMargin = 'card-design-footer-margin',
  CardDesignMetaMargin = 'card-design-meta-margin',
  CardDesignSearchMargin = 'card-design-search-margin',
  CardDesignFilterMargin = 'card-design-filter-margin',
  CardDesignLeadingButtonPadding = 'card-design-leading-button-padding',
  CardDesignTrailingButtonPadding = 'card-design-trailing-button-padding',
  CardDesignFooterGap = 'card-design-footer-gap',
  CardDesignHeaderSpacing = 'card-design-header-spacing',
  CardDesignImageSpacing = 'card-design-image-spacing',
  CardDesignFooterSectionSpacing = 'card-design-footer-section-spacing',
  CardDesignFooterTitleSpacing = 'card-design-footer-title-spacing',
  CardDesignContentTitleSpacing = 'card-design-content-title-spacing',
  CardDesignContentSubtitleSpacing = 'card-design-content-subtitle-spacing',
  CardDesignSupportingTextSpacing = 'card-design-supporting-text-spacing',
  CardDesignMetadataSpacing = 'card-design-metadata-spacing',
  CardDesignMediaMargin = 'card-design-media-margin',
  CardDesignHeadlineMargin = 'card-design-headline-margin',
  CardDesignMediaAspectRatio = 'card-design-media-aspect-ratio',
  CardDesignDividerBetweenTitle = 'card-design-divider-between-title',
  CardDesignDivider = 'card-design-divider',
  CardDesignHeaderTitleAlignment = 'card-design-header-title-align',
  CardDesignHeaderSubtitleAlignment = 'card-design-header-subtitle-align',
  CardDesignSupportingTextAlignment = 'card-design-supporting-text-align',
  CardDesignTitleAlignment = 'card-design-title-align',
  CardDesignSubtitleAlignment = 'card-design-subtitle-align',
  CardDesignMetaAlignment = 'card-design-meta-align',
  CardDesignActionAlignment = 'card-design-action-align',
  CardDesignMediaAlignment = 'card-design-media-align',
  CardDesignSearchAlignment = 'card-design-search-align',
  CardDesignPaginationAlignment = 'card-design-pagination-align',
  CardDesignTypography = 'card-design-typography',
  CardDesignHeaderTypography = 'card-design-header-typography',
  CardDesignSubHeaderTypography = 'card-design-subheader-typography',
  CardDesignTitleTypography = 'card-design-title-typography',
  CardDesignSubtitleTypography = 'card-design-subtitle-typography',
  CardDesignSupportingTextTypography = 'card-design-supporting-text-typography',
  CardDesignMetadataTypography = 'card-design-metadata-typography',
  CardDesignActionHelpTypography = 'card-design-action-help-typography',
  CardDesignHeadlineTypography = 'card-design-headline-typography',
  CardDesignGroupHeaderTypography = 'card-design-group-header-typography',
  CardDesignLeadingButtonTypography = 'card-design-leading-button-typography',
  CardDesignTrailingButtonTypography = 'card-design-trailing-button-typography',
  CardDesignNoTrunc = 'card-design-no-trunc',
  CardDesignTitleLines = 'card-design-title-lines',
  CardDesignSubtitleLines = 'card-design-subtitle-lines',
  CardDesignSubHeaderLines = 'card-design-subheader-lines',
  CardDesignSupportingTextLines = 'card-design-supporting-text-lines',
  CardDesignMetadataLines = 'card-design-metadata-lines',
  CardDesignHeaderLines = 'card-design-header-lines',
  CardDesignHoverEffect = 'card-design-hover-effect',
  CardDesignWidthGroup = 'card-design-width-group',
  CardDesignWidth = 'card-design-width',
  CardDesignLeadingButtonFullWidth = 'card-design-leading-button-full-width',
  CardDesignTrailingButtonFullWidth = 'card-design-trailing-button-full-width',
  CardDesignSearchBox = 'card-design-search-box',
  CardDesignCompHAlign = 'card-design-comp-h-align',
  CardDesignCompTitleAlign = 'card-design-comp-title-align',
  CardActionLeadingClick = 'card-action-leading-click',
  CardActionTrailingClick = 'card-action-trailing-click',
  CardDesignFilterBgColor = 'card-design-filter-bg-color',
  CardDesignFilterChipColor = 'card-design-filter-chip-color',
  CardDesignFilterCornerRadius = 'card-design-filter-corner-radius',
  CardBehaviorUserFilterPosition = 'card-behavior-user-filter-position',
  CardActionItemClick = 'card-action-item-click',
  CardBehaviorUserFilter = 'card-behavior-user-filter',
  CardBehaviorUserSearch = 'card-behavior-user-search',
  CardBehaviorSearchResultsInfo = 'card-behavior-search-results-info',
  CardDesignGroupTextColor = 'card-design-group-text-color',
  CardDesignText1Color = 'card-design-text-1-color',
  CardDesignText1ColorSolid = 'card-design-text-1-color-solid',
  CardDesignText1ColorStartGradient = 'card-design-text-1-color-start-gradient',
  CardDesignText1ColorEndGradient = 'card-design-text-1-color-end-gradient',
  CardDesignText1ColorGradientDirection = 'card-design-text-1-color-gradient-direction',
  CardDesignText2Color = 'card-design-text-2-color',
  CardDesignText2ColorSolid = 'card-design-text-2-color-solid',
  CardDesignText2ColorStartGradient = 'card-design-text-2-color-start-gradient',
  CardDesignText2ColorEndGradient = 'card-design-text-2-color-end-gradient',
  CardDesignText2ColorGradientDirection = 'card-design-text-2-color-gradient-direction',
  CardDesignText3Color = 'card-design-text-3-color',
  CardDesignText3ColorSolid = 'card-design-text-3-color-solid',
  CardDesignText3ColorStartGradient = 'card-design-text-3-color-start-gradient',
  CardDesignText3ColorEndGradient = 'card-design-text-3-color-end-gradient',
  CardDesignText3ColorGradientDirection = 'card-design-text-3-color-gradient-direction',
  CardDesignText4Color = 'card-design-text-4-color',
  CardDesignText4ColorSolid = 'card-design-text-4-color-solid',
  CardDesignText4ColorStartGradient = 'card-design-text-4-color-start-gradient',
  CardDesignText4ColorEndGradient = 'card-design-text-4-color-end-gradient',
  CardDesignText4ColorGradientDirection = 'card-design-text-4-color-gradient-direction',
  CardDesignText5Color = 'card-design-text-5-color',
  CardDesignText5ColorSolid = 'card-design-text-5-color-solid',
  CardDesignText5ColorStartGradient = 'card-design-text-5-color-start-gradient',
  CardDesignText5ColorEndGradient = 'card-design-text-5-color-end-gradient',
  CardDesignText5ColorGradientDirection = 'card-design-text-5-color-gradient-direction',
  CardDesignMetadataColor = 'card-design-metadata-color',
  CardDesignMetadataColorSolid = 'card-design-metadata-color-solid',
  CardDesignMetadataColorStartGradient = 'card-design-metadata-color-start-gradient',
  CardDesignMetadataColorEndGradient = 'card-design-metadata-color-end-gradient',
  CardDesignMetadataColorGradientDirection = 'card-design-metadata-color-gradient-direction',
  CardDesignFooterAreaColor = 'card-design-footer-area-color',
  CardDesignFooterAreaColorSolid = 'card-design-footer-area-color-solid',
  CardDesignFooterAreaColorStartGradient = 'card-design-footer-area-color-start-gradient',
  CardDesignFooterAreaColorEndGradient = 'card-design-footer-area-color-end-gradient',
  CardDesignFooterAreaColorGradientDirection = 'card-design-footer-area-color-gradient-direction',
  CardDesignGroupHeaderColorSolid = 'card-design-group-header-color-solid',
  CardDesignGroupHeaderColorStartGradient = 'card-design-group-header-color-start-gradient',
  CardDesignGroupHeaderColorEndGradient = 'card-design-group-header-color-end-gradient',
  CardDesignGroupHeaderColorGradientDirection = 'card-design-group-header-color-gradient-direction',
  CardDesignCompTitleColorSolid = 'card-design-comp-title-color-solid',
  CardDesignCompTitleColorStartGradient = 'card-design-comp-title-color-start-gradient',
  CardDesignCompTitleColorEndGradient = 'card-design-comp-title-color-end-gradient',
  CardDesignCompTitleColorGradientDirection = 'card-design-comp-title-color-gradient-direction',
  CardDesignAddButtonColor = 'card-design-add-button-color',
  CardDesignAddButtonCornerRadius = 'card-design-add-button-corner-radius',
  CardBehaviorAddButtonShow = 'card-behavior-add-button-show',
  CardBehaviorAddButtonPosition = 'card-behavior-add-button-position',
  CardBehaviorAddButtonVisibility = 'card-behavior-add-button-visibility',
  CardActionAddButtonClick = 'card-action-add-button-click',

  AccordionDataSource = 'accordion-data-source',
  AccordionDataFilterableColumns = 'accordion-data-filterable-columns',
  AccordionDataTitle = 'accordion-data-title',
  AccordionDataContent = 'accordion-data-content',
  AccordionDataIcon = 'accordion-data-icon',
  AccordionDataExpandedIcon = 'accordion-data-expanded-icon',
  AccordionDataCompTitle = 'accordion-data-comp-title',
  AccordionDataSortBy = 'accordion-data-sort-by',
  AccordionDataSortType = 'accordion-data-sort-type',
  AccordionDataFilter = 'accordion-data-filter',
  AccordionDataGroupBy = 'accordion-data-group-by',
  AccordionDesignScheme = 'accordion-design-scheme',
  AccordionDesignGroupTextColor = 'accordion-design-group-text-color',
  AccordionDesignSearchCornerRadius = 'accordion-design-search-corner-radius',
  AccordionDesignTextColor = 'accordion-design-text-color',
  AccordionDesignTextColorSolid = 'accordion-design-text-color-solid',
  AccordionDesignTextColorStartGradient = 'accordion-design-text-color-start-gradient',
  AccordionDesignTextColorEndGradient = 'accordion-design-text-color-end-gradient',
  AccordionDesignTextColorGradientDirection = 'accordion-design-text-color-gradient-direction',
  AccordionDesignContentColor = 'accordion-design-content-color',
  AccordionDesignContentColorSolid = 'accordion-design-content-color-solid',
  AccordionDesignContentColorStartGradient = 'accordion-design-content-color-start-gradient',
  AccordionDesignContentColorEndGradient = 'accordion-design-content-color-end-gradient',
  AccordionDesignContentColorGradientDirection = 'accordion-design-content-color-gradient-direction',
  AccordionDesignTitleColorSolid = 'accordion-design-title-color-solid',
  AccordionDesignTitleColorStartGradient = 'accordion-design-title-color-start-gradient',
  AccordionDesignTitleColorEndGradient = 'accordion-design-title-color-end-gradient',
  AccordionDesignTitleColorGradientDirection = 'accordion-design-title-color-gradient-direction',
  AccordionDesignGroupHeaderColorSolid = 'accordion-design-group-header-color-solid',
  AccordionDesignGroupHeaderColorStartGradient = 'accordion-design-group-header-color-start-gradient',
  AccordionDesignGroupHeaderColorEndGradient = 'accordion-design-group-header-color-end-gradient',
  AccordionDesignGroupHeaderColorGradientDirection = 'accordion-design-group-header-color-gradient-direction',
  AccordionDesignOutlineColor = 'accordion-design-outline-color',
  AccordionDesignTitleColor = 'accordion-design-title-color',
  AccordionDesignHeaderBgColor = 'accordion-design-header-bg-color',
  AccordionDesignContentBgColor = 'accordion-design-content-bg-color',
  AccordionDesignHeaderItemColor = 'accordion-design-header-item-color',
  AccordionDesignContentItemColor = 'accordion-design-content-item-color',
  AccordionDesignGroupHeaderColor = 'accordion-design-group-header-color',
  AccordionDesignAddButtonColor = 'accordion-design-add-button-color',
  AccordionDesignAddButtonCornerRadius = 'accordion-design-add-button-corner-radius',
  AccordionBehaviorAddButtonShow = 'accordion-behavior-add-button-show',
  AccordionBehaviorAddButtonPosition = 'accordion-behavior-add-button-position',
  AccordionBehaviorAddButtonVisibility = 'accordion-behavior-add-button-visibility',
  AccordionActionAddButtonClick = 'accordion-action-add-button-click',

  AccordionDesignIconLeading = 'accordion-design-icon-leading',
  AccordionDesignOutlineBorderWidth = 'accordion-design-outline-border-width',
  AccordionDesignRoundedCorner = 'accordion-design-rounded-corner',
  AccordionDesignContentLeading = 'accordion-design-content-padding',
  AccordionDesignWidth = 'accordion-design-width',
  AccordionDesignSearchWidth = 'accordion-design-search-width',
  AccordionDesignSearchColor = 'accordion-design-search-color',
  AccordionDesignGroupSearchAlign = 'accordion-design-group-search-align',
  AccordionDesignSearchMargin = 'accordion-design-search-margin',
  AccordionDesignTitleMargin = 'accordion-design-title-margin',
  AccordionDesignComponentMargin = 'accordion-design-component-margin',
  AccordionDesignComponentPadding = 'accordion-design-component-padding',
  AccordionDesignPanelHeaderMargin = 'accordion-design-panel-header-margin',
  AccordionDesignPanelContentMargin = 'accordion-design-panel-content-margin',
  AccordionDesignGroupHeaderMargin = 'accordion-design-group-header-margin',
  AccordionDesignAlignmentTitle = 'accordion-design-alignment-title',
  AccordionDesignAlignmentComponent = 'accordion-design-alignment-component',
  AccordionDesignAlignmentPanelHeader = 'accordion-design-alignment-panel-header',
  AccordionDesignAlignmentPanelContent = 'accordion-design-alignment-panel-content',
  AccordionDesignAlignmentGroupHeader = 'accordion-design-alignment-group-header',
  AccordionDesignAlignmentTitleAccordion = 'accordion-design-alignment-title-accordion',
  AccordionDesignAlignmentContentAccordion = 'accordion-design-alignment-content-accordion',
  AccordionDesignTypography = 'accordion-design-typography',
  AccordionDesignItemsPerPage = 'accordion-design-items-per-page',
  AccordionDesignTitleTypography = 'accordion-design-title-typography',
  AccordionDesignHeaderTypography = 'accordion-design-header-typography',
  AccordionDesignContentTypography = 'accordion-design-content-typography',
  AccordionDesignGroupHeaderTypography = 'accordion-design-group-header-typography',
  AccordionDesignHoverEffect = 'accordion-design-hover-effect',
  AccordionBehaviorMultiExpand = 'accordion-behavior-multi-expand',
  AccordionBehaviorUserSearch = 'accordion-behavior-user-search',
  AccordionBehaviorSearchResultsInfo = 'accordion-behavior-search-results-info',
  AccordionBehaviorUserFilter = 'accordion-behavior-user-filter',

  EventDataSource = 'event-data-source',
  EventDataFilterableColumns = 'event-data-filterable-columns',
  EventDataTitle = 'event-data-title',
  EventDataDescription = 'event-data-description',
  EventDataImage = 'event-data-image',
  EventDataStartDate = 'event-data-start-date',
  EventDataEndDate = 'event-data-end-date',
  EventDataPrice = 'event-data-price',
  EventDataVenue = 'event-data-venue',
  EventDataLike = 'event-data-like',
  EventDataTag = 'event-data-tag',
  EventDataNumItems = 'event-data-num-items',
  EventDataSortBy = 'event-data-sort-by',
  EventDataSortType = 'event-data-sort-type',
  EventDataFilter = 'event-data-filter',
  EventDesignScheme = 'event-design-scheme',
  EventDesignLikeIcon = 'event-design-like-icon',
  EventDesignYear = 'event-design-year',
  EventDesignCounter = 'event-design-counter',
  EventDesignLikeCounter = 'event-design-like-counter',
  EventDesignTypography = 'event-design-typography',
  EventDesignMonthTypography = 'event-design-month-typography',
  EventDesignCounterTypography = 'event-design-counter-typography',
  EventDesignDateTypography = 'event-design-date-typography',
  EventDesignDayTypography = 'event-design-day-typography',
  EventDesignTitleTypography = 'event-design-title-typography',
  EventDesignDescriptionTypography = 'event-design-description-typography',
  EventActionItemClick = 'event-action-item-click',
  EventActionLikeClick = 'event-action-like-click',
  EventBehaviorUserFilter = 'event-behavior-user-filter',

  // gallery
  GalleryDataSource = 'gallery-data-source',
  GalleryDataCompTitle = 'gallery-data-comp-title',
  GalleryDataFilterableColumns = 'gallery-data-filterable-columns',
  GalleryDataImage = 'gallery-data-image',
  GalleryDataCaption = 'gallery-data-caption',
  GalleryDataAvatar = 'gallery-data-avatar',
  GalleryDataLike = 'gallery-data-like',
  GalleryDataTag = 'gallery-data-tag',
  GalleryDataNumItems = 'gallery-data-num-items',
  GalleryDefaultPerPage = 'gallery-default-per-page',
  GalleryDesignNumCols = 'gallery-design-num-cols',
  GalleryDesignNumRows = 'gallery-design-num-rows',
  GalleryDesignPagination = 'gallery-design-pagination',
  GalleryDataSortBy = 'gallery-data-sort-by',
  GalleryDataSortType = 'gallery-data-sort-type',
  GalleryDataFilter = 'gallery-data-filter',
  GalleryDataGroupBy = 'gallery-data-group-by',
  GalleryDesignScheme = 'gallery-design-scheme',
  GalleryDesignWidth = 'gallery-design-width',
  GalleryDesignSearchWidth = 'gallery-design-search-width',
  GalleryDesignCaptionColor = 'gallery-design-caption-color',
  GalleryDesignCompTitleColor = 'gallery-design-comp-title-color',
  GalleryDesignSearchBgColor = 'gallery-design-search-bg-color',
  GalleryDesignCompHAlign = 'gallery-design-comp-h-align',
  GalleryDesignCompItemsAlign = 'gallery-design-comp-items-align',
  GalleryDesignGroupHeaderAlign = 'gallery-design-group-header-align',
  GalleryDesignCompTitleAlign = 'gallery-design-comp-title-align',
  GalleryDesignPaginationAlign = 'gallery-design-pagination-align',
  GalleryDesignCaptionAlign = 'gallery-design-caption-align',
  GalleryDesignSearchAlignment = 'gallery-design-search-align',
  GalleryDesignLayout = 'gallery-design-layout',
  GalleryDesignCarouselArrow = 'gallery-design-carousel-arrow',
  GalleryDesignCarouselIndicator = 'gallery-design-carousel-indicator',
  GalleryDesignCarousellCaptionVAlign = 'gallery-design-carousel-caption-valign',
  GalleryDesignLikeIcon = 'gallery-design-like-icon',
  GalleryDesignImageShape = 'gallery-design-image-shape',
  GalleryDesignAvatarShape = 'gallery-design-avatar-shape',
  GalleryDesignSearchCorner = 'gallery-design-search-corner',
  GalleryDesignTypography = 'gallery-design-typography',
  GalleryDesignHoverEffect = 'gallery-design-hover-effect',
  GalleryDesignCaptionTypography = 'gallery-design-caption-typography',
  GalleryDesignTagTypography = 'gallery-design-tag-typography',
  GalleryDesignHeadlineTypography = 'gallery-design-headline-typography',
  GalleryDesignGroupHeaderTypography = 'gallery-design-group-header-typography',
  GalleryDesignCompTitleTypography = 'gallery-design-comp-title-typography',
  GalleryDesignMargin = 'gallery-design-margin',
  GalleryDesignHeadlineMargin = 'gallery-design-headline-margin',
  GalleryDesignSearchMargin = 'gallery-design-search-margin',
  GalleryDesignFilterMargin = 'gallery-design-filter-margin',
  GalleryDesignGap = 'gallery-design-gap',
  GalleryDesignGroupHeaderMargin = 'gallery-design-group-header-margin',
  GalleryDesignAspectRatio = 'gallery-design-aspect-ratio',
  GalleryDesignFilterBgColor = 'gallery-design-filter-bg-color',
  GalleryDesignFilterChipColor = 'gallery-design-filter-chip-color',
  GalleryDesignFilterCornerRadius = 'gallery-design-filter-corner-radius',
  GalleryBehaviorUserFilterPosition = 'gallery-behavior-user-filter-position',
  GalleryActionItemClick = 'gallery-action-item-click',
  GalleryActionSelect = 'gallery-action-select',
  GalleryBehaviorUserFilter = 'gallery-behavior-user-filter',
  GalleryBehaviorUserSearch = 'gallery-behavior-user-search',
  GalleryBehaviorSearchResultsInfo = 'gallery-behavior-search-results-info',
  GalleryBehaviorAddButtonShow = 'gallery-behavior-add-button-show',
  GalleryBehaviorAddButtonPosition = 'gallery-behavior-add-button-position',
  GalleryBehaviorAddButtonVisibility = 'gallery-behavior-add-button-visibility',
  GalleryActionAddButtonClick = 'gallery-action-add-button-click',
  GalleryDesignAddButtonColor = 'gallery-design-add-button-color',
  GalleryDesignAddButtonCornerRadius = 'gallery-design-add-button-corner-radius',

  ArrayGalleryDataSource = 'array-gallery-data-source',
  ArrayGalleryDataUseDetailScreen = 'array-gallery-data-use-detail-screen',
  ArrayGalleryDataImage = 'array-gallery-data-image',
  ArrayGalleryDataCompTitle = 'array-gallery-data-comp-title',
  ArrayGalleryDesignScheme = 'array-gallery-design-scheme',
  ArrayGalleryDesignComponentTitleColor = 'array-gallery-design-component-title-color',
  ArrayGalleryDesignCarouselBackgroundColor = 'array-gallery-design-carousel-background-color',
  ArrayGalleryDesignLayout = 'array-gallery-design-layout',
  ArrayGalleryDesignWidth = 'array-gallery-design-width',
  ArrayGalleryDesignModalWidth = 'array-gallery-design-modal-width',
  ArrayGalleryDesignCompHAlign = 'array-gallery-design-comp-h-align',
  ArrayGalleryDesignCompTitleHAlign = 'array-gallery-design-comp-title-h-align',
  ArrayGalleryDesignCarouselArrow = 'array-gallery-design-carousel-arrow',
  ArrayGalleryDesignCarouselIndicator = 'array-gallery-design-carousel-indicator',
  ArrayGalleryDesignMargin = 'array-gallery-design-margin',
  ArrayGalleryDesignHeadlineMargin = 'array-gallery-design-headline-margin',
  ArrayGalleryDesignImageShape = 'array-gallery-design-image-shape',
  ArrayGalleryDesignAvatarShape = 'array-gallery-design-avatar-shape',
  ArrayGalleryDesignAspectRatio = 'array-gallery-design-aspect-ratio',
  ArrayGalleryDesignHideTitle = 'array-gallery-design-hide-title',
  ArrayGalleryDesignTypography = 'array-gallery-design-typography',
  ArrayGalleryDesignCaptionTypography = 'array-gallery-design-caption-typography',
  ArrayGalleryDesignGap = 'array-gallery-design-gap',
  ArrayGalleryDesignHeadlineTypography = 'array-gallery-design-headline-typography',
  ArrayGalleryDesignNumCols = 'array-gallery-design-num-cols',
  ArrayGalleryDataNumItems = 'array-gallery-data-num-items',
  ArrayGalleryDataLimitArrayItem = 'array-gallery-data-limit-item',
  ArrayGalleryDataNumArrayItems = 'array-gallery-data-num-array-items',
  ArrayGalleryActionItemClick = 'array-gallery-action-item-click',
  ArrayGalleryActionSelect = 'array-gallery-action-select',

  // text field
  TextFieldDataValue = 'text-field-data-value',
  TextFieldDataDefaultValue = 'text-field-data-default-value',
  TextFieldDataDefaultValueEditable = 'text-field-data-default-value-editable',
  TextFieldDataLabel = 'text-field-data-label',
  TextFieldDataHelp = 'text-field-data-help',
  TextFieldDataPrefix = 'text-field-data-prefix',
  TextFieldDataSuffix = 'text-field-data-suffix',
  TextFieldDataLeadingIcon = 'text-field-data-leading-icon',
  TextFieldDataTrailingIcon = 'text-field-data-trailing-icon',
  TextFieldDesignScheme = 'text-field-design-scheme',
  TextFieldDesignColorVariant = 'text-field-design-color-variant',
  TextFieldDesignOutlined = 'text-field-design-outlined',
  TextFieldDesignHeight = 'text-field-design-height',
  TextFieldDesignWidth = 'text-field-design-width',
  TextFieldDesignMargin = 'text-field-design-margin',
  TextFieldDesignTypography = 'text-field-design-typography',
  TextFieldDesignLabelTypography = 'text-field-design-label-typography',
  TextFieldDesignInputTypography = 'text-field-design-input-typography',
  TextFieldDesignHelpTypography = 'text-field-design-help-typography',
  TextFieldBehaviorInputType = 'text-field-behavior-input-type',
  TextFieldBehaviorPattern = 'text-field-behavior-pattern',
  TextFieldBehaviorPatternShowHelp = 'text-field-behavior-pattern-show-help',
  TextFieldBehaviorRequired = 'text-field-behavior-required',
  TextFieldBehaviorCharacterCounter = 'text-field-behavior-character-counter',
  TextFieldBehaviorPasswordMask = 'text-field-behavior-password-mask',
  TextFieldBehaviorMaxChar = 'text-field-behavior-max-char',
  TextFieldBehaviorMinChar = 'text-field-behavior-min-char',
  TextFieldBehaviorMaxNum = 'text-field-behavior-max-num',
  TextFieldBehaviorMinNum = 'text-field-behavior-min-num',

  SwitchDataValue = 'switch-data-value',
  SwitchDataDefaultValue = 'switch-data-default-value',
  SwitchDataDefaultValueEditable = 'switch-data-default-value-editable',
  SwitchDataLabel = 'switch-data-label',
  SwitchDataIcon = 'switch-data-icon',
  SwitchDataIconOff = 'switch-data-icon-off',
  SwitchDataWriteTo = 'switch-data-write-to',
  SwitchDesignScheme = 'switch-design-scheme',
  SwitchDesignColorVariant = 'switch-design-color-variant',
  SwitchDesignIcon = 'switch-design-icon',
  SwitchDesignMargin = 'switch-design-margin',
  SwitchActionValueOn = 'switch-action-value-on',
  SwitchActionValueOff = 'switch-action-value-off',
  SwitchBehaviorRequired = 'switch-behavior-required',

  FieldRatingDataValue = 'field-rating-data-value',
  FieldRatingDataLabel = 'field-rating-data-label',
  FieldRatingDataDefaultValue = 'field-rating-data-default-value',
  FieldRatingDataDefaultValueEditable = 'field-rating-data-default-value-editable',
  FieldRatingBehaviorRequired = 'field-rating-behavior-required',

  MultiSelectionDataValue = 'multi-selection-data-value',
  MultiSelectionDataOptionsSource = 'multi-selection-data-options-source',
  MultiSelectionDataOptionsValue = 'multi-selection-data-options-value',
  MultiSelectionDataOptionsLabel = 'multi-selection-data-options-label',
  MultiSelectionDesignScheme = 'multi-selection-design-scheme',
  MultiSelectionDesignColorVariant = 'multi-selection-design-color-variant',
  MultiSelectionDesignMargin = 'multi-selection-design-margin',

  CheckboxDataValue = 'checkbox-data-value',
  CheckboxDataDefaultValue = 'checkbox-data-default-value',
  CheckboxDataDefaultValueEditable = 'checkbox-data-default-value-editable',
  CheckboxDataLabel = 'checkbox-data-label',
  CheckboxBehaviorRequired = 'checkbox-behavior-required',
  CheckboxDesignScheme = 'checkbox-design-scheme',
  CheckboxDesignColorVariant = 'checkbox-design-color-variant',
  CheckboxDesignMargin = 'checkbox-design-margin',
  CheckboxActionValueOn = 'checkbox-action-value-on',
  CheckboxActionValueOff = 'checkbox-action-value-off',

  RadioDataValue = 'radio-data-value',
  RadioDataOptionsSource = 'radio-data-options-source',
  RadioDataOptionsValue = 'radio-data-options-value',
  RadioDataOptionsLabel = 'radio-data-options-label',
  RadioDataFilter = 'radio-data-filter',
  RadioDesignScheme = 'radio-design-scheme',
  RadioDesignColorVariant = 'radio-design-color-variant',
  RadioDesignMargin = 'radio-design-margin',
  RadioActionValueChange = 'radio-action-value-change',

  SelectionDataValue = 'selection-data-value',
  SelectionDataDefaultValue = 'selection-data-default-value',
  SelectionDataDefaultValueEditable = 'selection-data-default-value-editable',
  SelectionDataMultiple = 'selection-data-multiple',
  SelectionDataSeparator = 'selection-data-separator',
  SelectionDataOptionsSource = 'selection-data-options-source',
  SelectionDataOptionsValue = 'selection-data-options-value',
  SelectionDataOptionsLabel = 'selection-data-options-label',
  SelectionDataOptionsIcon = 'selection-data-options-icon',
  SelectionDataLabel = 'selection-data-label',
  SelectionDataHelp = 'selection-data-help',
  SelectionDataWriteTo = 'selection-data-write-to',
  SelectionDataOptionsSortBy = 'selection-data-options-sort-by',
  SelectionDataOptionsSortType = 'selection-data-options-sort-type',
  SelectionDataOptionsFilter = 'selection-data-options-filter',
  SelectionDesignScheme = 'selection-design-scheme',
  SelectionDesignColorVariant = 'selection-design-color-variant',
  SelectionDesignType = 'selection-design-type',
  SelectionDesignOutlined = 'selection-design-outlined',
  SelectionDesignLeadingIcon = 'selection-design-leading-icon',
  SelectionDesignWidth = 'selection-design-width',
  SelectionDesignMargin = 'selection-design-margin',
  SelectionActionValueChange = 'selection-action-value-change',
  SelectionBehaviorRequired = 'selection-behavior-required',

  DateTimePickerDataValue = 'datetime-picker-data-value',
  DateTimePickerDataDefaultValue = 'datetime-picker-data-default-value',
  DateTimePickerDataDefaultValueEditable = 'datetime-picker-data-default-value-editable',
  DateTimePickerDataLabel = 'datetime-picker-data-label',
  DateTimePickerDesignTimePickerVariant = 'datetime-picker-design-time-picker-variant',
  DateTimePickerDesignMargin = 'datetime-picker-design-margin',
  DateTimePickerBehaviorShowTime = 'datetime-picker-behavior-show-time',
  DateTimePickerBehaviorRequired = 'datetime-picker-behavior-required',
  DateTimePickerBehaviorMinDate = 'datetime-picker-behavior-min-date',
  DateTimePickerBehaviorMaxDate = 'datetime-picker-behavior-max-date',
  DateTimePickerBehaviorFutureDateOnly = 'datetime-picker-behavior-future-date-only',
  DateTimePickerBehaviorDaysAllowed = 'datetime-picker-behavior-days-allowed',
  DateTimePickerBehaviorTimeInterval = 'datetime-picker-behavior-time-interval',
  DateTimePickerBehaviorStartTime = 'datetime-picker-behavior-start-time',
  DateTimePickerBehaviorEndTime = 'datetime-picker-behavior-end-time',

  SliderDataRange = 'slider-data-range',
  SliderDataValue = 'slider-data-value',
  SliderDataEndValue = 'slider-data-end-value',
  SliderDataLabel = 'slider-data-label',
  SliderDataHelp = 'slider-data-help',
  SliderDataDefaultValue = 'slider-data-default-value',
  SliderDataDefaultValueEditable = 'slider-data-default-value-editable',
  SliderDesignTickMark = 'slider-design-tick-mark',
  SliderDesignThickness = 'slider-design-thickness',
  SliderDesignWidth = 'slider-design-width',
  SliderDesignPadding = 'slider-design-padding',
  SliderDesignShowMinMaxValues = 'slider-design-show-min-max-values',
  SliderDesignShowMinMaxLabels = 'slider-design-show-min-max-labels',
  SliderBehaviorMinValue = 'slider-data-min-value',
  SliderBehaviorMaxValue = 'slider-data-max-value',
  SliderBehaviorStepValue = 'slider-data-step-value',
  SliderBehaviorRequired = 'slider-behavior-required',

  // attachment
  FileUploadDataSource = 'file-upload-data-source',
  FileUploadDataValue = 'file-upload-data-value',
  FileUploadDataDefaultValue = 'file-upload-data-default-value',
  FileUploadDataLabel = 'file-upload-data-label',
  FileUploadDataIcon = 'file-upload-data-icon',
  FileUploadDataHelp = 'file-upload-data-help',
  FileUploadDesignWidth = 'file-upload-design-width',
  FileUploadDesignScheme = 'file-upload-design-scheme',
  FileUploadDesignOutlined = 'file-upload-design-outlined',
  FileUploadDesignTypography = 'file-upload-design-typography',
  FileUploadDesignLabelTypography = 'file-upload-design-label-typography',
  FileUploadDesignInputTypography = 'file-upload-design-input-typography',
  FileUploadDesignHelpTypography = 'file-upload-design-help-typography',
  FileUploadBehaviorMaxSize = 'file-upload-behavior-max-size',
  FileUploadBehaviorAllowedFileTypes = 'file-upload-allowed-file-types',
  FileUploadBehaviorRequired = 'file-upload-behavior-required',
  FileUploadBehaviorShowHelpText = 'file-upload-behavior-show-help-text',

  ImageUploadDataSource = 'image-upload-data-source',
  ImageUploadDataValue = 'image-upload-data-value',
  ImageUploadDataDefaultValue = 'image-upload-data-default-value',
  ImageUploadDataLabel = 'image-upload-data-label',
  ImageUploadDataHelp = 'image-upload-data-help',
  ImageUploadDesignWidth = 'image-upload-design-width',
  ImageUploadDesignScheme = 'image-upload-design-scheme',
  ImageUploadDesignOutlined = 'image-upload-design-outlined',
  ImageUploadDesignTypography = 'image-upload-design-typography',
  ImageUploadDesignLabelTypography = 'image-upload-design-label-typography',
  ImageUploadDesignInputTypography = 'image-upload-design-input-typography',
  ImageUploadDesignHelpTypography = 'image-upload-design-help-typography',
  ImageUploadBehaviorMaxSize = 'image-upload-behavior-max-size',
  ImageUploadBehaviorCompressionMaxSize = 'image-upload-behavior-compression-max-size',
  ImageUploadBehaviorAllowedFileTypes = 'image-upload-allowed-file-types',
  ImageUploadBehaviorShowHelpText = 'image-upload-behavior-show-help-text',
  ImageUploadBehaviorRequired = 'image-upload-behavior-required',
  ImageUploadBehaviorMaxItems = 'image-upload-behavior-max-items',

  MenuDataSource = 'menu-data-source',
  MenuDataTitle = 'menu-data-title',
  MenuDesignScheme = 'menu-design-scheme',
  MenuDesignHeadingColor = 'menu-design-heading-color',
  MenuDesignItemColor = 'menu-design-item-color',
  MenuDesignTypography = 'menu-design-typography',
  MenuDesignTitleTypography = 'menu-design-title-typography',
  MenuDesignRowHeaderTypography = 'menu-design-row-header-typography',
  MenuDesignShowIcon = 'menu-design-show-icon',
  MenuDesignOrientation = 'menu-design-orientation',
  MenuDesignComponentHAlign = 'menu-design-comp-h-align',
  MenuDesignHeadingHAlign = 'menu-design-heading-h-align',
  MenuDesignItemHAlign = 'menu-design-item-h-align',
  MenuDesignComponentMargin = 'menu-design-comp-margin',
  MenuDesignHeadingMargin = 'menu-design-heading-margin',
  MenuDesignItemMargin = 'menu-design-item-margin',

  VerticalMenuDataSource = 'vertical-menu-data-source',
  VerticalMenuDesignTypography = 'vertical-menu-design-typography',
  VerticalMenuDesignTitleTypography = 'vertical-menu-design-title-typography',
  VerticalMenuDesignItemsTypography = 'vertical-menu-design-items-typography',
  VerticalMenuDesignCompMargin = 'vertical-menu-design-comp-margin',
  VerticalMenuDesignTitleMargin = 'vertical-menu-design-title-margin',
  VerticalMenuDesignItemsMargin = 'vertical-menu-design-items-margin',
  VerticalMenuDesignSpacing = 'vertical-menu-design-spacing',
  VerticalMenuDesignOrientation = 'vertical-menu-design-orientation',
  VerticalMenuDesignAlignment = 'vertical-menu-design-alignment',
  VerticalMenuDesignItemsAlignment = 'vertical-menu-design-items-alignment',
  VerticalMenuDesignGroupColor = 'vertical-menu-design-group-color',
  VerticalMenuDesignHoverEffect = 'vertical-menu-design-hover-effect',
  VerticalMenuDesignTitleColor = 'vertical-menu-design-title-color',
  VerticalMenuDesignTitleColorSolid = 'vertical-menu-design-title-color-solid',
  VerticalMenuDesignTitleColorStartGradient = 'vertical-menu-design-title-color-start-gradient',
  VerticalMenuDesignTitleColorEndGradient = 'vertical-menu-design-title-color-end-gradient',
  VerticalMenuDesignTitleColorGradientDirection = 'vertical-menu-design-title-color-gradient-direction',
  VerticalMenuDesignScheme = 'vertical-menu-design-scheme',
  VerticalMenuDesignItemsColor = 'vertical-menu-design-items-color',
  VerticalMenuDesignItemsColorSolid = 'vertical-menu-design-items-color-solid',
  VerticalMenuDesignItemsColorStartGradient = 'vertical-menu-design-items-color-start-gradient',
  VerticalMenuDesignItemsColorEndGradient = 'vertical-menu-design-items-color-end-gradient',
  VerticalMenuDesignItemsColorGradientDirection = 'vertical-menu-design-items-color-gradient-direction',
  VerticalMenuDataMaxVisibleItems = 'vertical-menu-data-max-visible-items',
  VerticalMenuDataOverflowIcon = 'vertical-menu-data-overflow-icon',
  VerticalMenuDesignOverflowMenuProps = 'vertical-menu-design-overflow-menu-props',
  VerticalMenuDesignOverflowMenuBackgroundColor = 'vertical-menu-design-overflow-menu-background-color',
  VerticalMenuDesignOverflowMenuDropdownAlign = 'vertical-menu-design-overflow-menu-dropdown-align',
  VerticalMenuBehaviorShowIcon = 'vertical-menu-design-show-icon',
  VerticalMenuBehaviorShowTitle = 'vertical-menu-design-show-title',

  RatingDataSource = 'rating-data-source',
  RatingDataValue = 'rating-data-value',
  RatingDataCount = 'rating-data-count',
  RatingDataInterval = 'rating-data-interval',
  RatingDataText = 'rating-data-text',
  RatingData1Start = 'rating-data-1-start',
  RatingData2Start = 'rating-data-2-start',
  RatingData3Start = 'rating-data-3-start',
  RatingData4Start = 'rating-data-4-start',
  RatingData5Start = 'rating-data-5-start',
  RatingDesignSize = 'rating-design-size',
  RatingDesignScheme = 'rating-design-scheme',
  RatingDesignColor = 'rating-design-color',
  RatingDesignColorSolid = 'rating-design-color-solid',
  RatingDesignHAlign = 'rating-design-h-align',
  RatingDesignVariant = 'rating-design-variant',
  RatingDesignWidth = 'rating-design-width',
  RatingDesignMargin = 'rating-design-margin',
  RatingDesignProgressColor = 'rating-design-progress-color',
  RatingActionClick = 'rating-action-click',

  StopwatchDataSource = 'stopwatch-data-source',
  StopwatchDataDuration = 'stopwatch-data-duration',
  StopwatchDesignScheme = 'stopwatch-design-scheme',
  StopwatchBehaviorResetWarning = 'stopwatch-behavior-reset-warning',
  StopwatchBehaviorStartCountdown = 'stopwatch-behavior-start-countdown',
  StopwatchBehaviorCountdownSound = 'stopwatch-behavior-countdown-sound',

  CommentDataSource = 'comment-data-source',
  CommentDataComment = 'comment-data-comment',
  CommentDataAuthor = 'comment-data-author',
  CommentDataAvatar = 'comment-data-avatar',
  CommentDataDate = 'comment-data-date',
  CommentDataLikes = 'comment-data-likes',
  CommentDataDislikes = 'comment-data-dislikes',
  CommentDataApproved = 'comment-data-status',
  CommentDataParent = 'comment-data-parent',
  CommentDataUser = 'comment-data-user',
  CommentDataSortBy = 'comment-data-sort-by',
  CommentDataSortType = 'comment-data-sort-type',
  CommentDataFilter = 'comment-data-filter',
  CommentDataLimit = 'comment-data-limit',
  CommentDataActionMenu = 'comment-data-action-menu',
  CommentDesignWidth = 'comment-design-width',
  CommentDesignCompHAlign = 'comment-design-comp-h-align',
  CommentDesignMargin = 'comment-design-margin',
  CommentDesignItemGap = 'comment-design-item-gap',
  CommentDesignTypography = 'comment-design-typography',
  CommentDesignDateTypography = 'comment-design-date-typography',
  CommentDesignAuthorTypography = 'comment-design-author-typography',
  CommentDesignReplyButtonTypography = 'comment-design-reply-button-typography',
  CommentDesignBodyTypography = 'comment-design-body-typography',
  CommentDesignShowLikeCount = 'comment-design-show-like-count',
  CommentDesignShowDislikeCount = 'comment-design-show-dislike-count',
  CommentDesignHoverEffect = 'comment-design-hover-effect',
  CommentActionCommentSubmit = 'comment-action-comment-submit',
  CommentActionReplySubmit = 'comment-action-reply-submit',
  CommentActionAuthorClick = 'comment-action-author-click',
  CommentActionLikeClick = 'comment-action-like-click',
  CommentActionDislikeClick = 'comment-action-dislike-click',
  CommentBehaviorAutoApprove = 'comment-behavior-auto-approve',
  CommentBehaviorShowLikeCount = 'comment-behavior-show-like-count',
  CommentBehaviorShowDislikeCount = 'comment-behavior-show-dislike-count',
  CommentDesignScheme = 'comment-design-scheme',
  CommentDesignGroupTextColor = 'comment-design-group-text-color',
  CommentDesignCommentColor = 'comment-design-comment-color',
  CommentDesignCommentColorSolid = 'comment-design-comment-color-solid',
  CommentDesignCommentColorStartGradient = 'comment-design-comment-color-start-gradient',
  CommentDesignCommentColorEndGradient = 'comment-design-comment-color-end-gradient',
  CommentDesignCommentColorGradientDirection = 'comment-design-comment-color-gradient-direction',
  CommentDesignAuthorNameColor = 'comment-design-author-name-color',
  CommentDesignAuthorNameColorSolid = 'comment-design-author-name-color-solid',
  CommentDesignAuthorNameColorStartGradient = 'comment-design-author-name-color-start-gradient',
  CommentDesignAuthorNameColorEndGradient = 'comment-design-author-name-color-end-gradient',
  CommentDesignAuthorNameColorGradientDirection = 'comment-design-author-name-color-gradient-direction',
  CommentDesignAuthorAvatarColor = 'comment-design-author-avatar-color',
  CommentDesignAuthorAvatarColorSolid = 'comment-design-author-avatar-color-solid',
  CommentDesignAuthorAvatarColorStartGradient = 'comment-design-author-avatar-color-start-gradient',
  CommentDesignAuthorAvatarColorEndGradient = 'comment-design-author-avatar-color-end-gradient',
  CommentDesignAuthorAvatarColorGradientDirection = 'comment-design-author-avatar-color-gradient-direction',
  CommentDesignTimeColor = 'comment-design-time-color',
  CommentDesignTimeColorSolid = 'comment-design-time-color-solid',
  CommentDesignTimeColorStartGradient = 'comment-design-time-color-start-gradient',
  CommentDesignTimeColorEndGradient = 'comment-design-time-color-end-gradient',
  CommentDesignTimeColorGradientDirection = 'comment-design-time-color-gradient-direction',
  CommentDesignLikeColor = 'comment-design-like-color',
  CommentDesignLikeColorSolid = 'comment-design-like-color-solid',
  CommentDesignLikeColorStartGradient = 'comment-design-like-color-start-gradient',
  CommentDesignLikeColorEndGradient = 'comment-design-like-color-end-gradient',
  CommentDesignLikeColorGradientDirection = 'comment-design-like-color-gradient-direction',
  CommentDesignDislikeColor = 'comment-design-dislike-color',
  CommentDesignDislikeColorSolid = 'comment-design-dislike-color-solid',
  CommentDesignDislikeColorStartGradient = 'comment-design-dislike-color-start-gradient',
  CommentDesignDislikeColorEndGradient = 'comment-design-dislike-color-end-gradient',
  CommentDesignDislikeColorGradientDirection = 'comment-design-dislike-color-gradient-direction',

  HiddenFieldDataValue = 'hidden-field-data-value',
  HiddenFieldDataAttribute = 'hidden-field-data-attribute',
  HiddenFieldDataDefaultValue = 'hidden-field-data-default-value',
  HiddenFieldDataDefaultValue2 = 'hidden-field-data-default-value-2',

  QuantityDataSource = 'quantity-data-source',
  QuantityDataMin = 'quantity-data-min',
  QuantityDataMax = 'quantity-data-max',
  QuantityDataValue = 'quantity-data-value',
  QuantityDataLabel = 'quantity-data-label',
  QuantityDesignScheme = 'quantity-design-scheme',
  QuantityDesignButtonColor = 'quantity-design-button-color',
  QuantityDesignGroupColor = 'quantity-design-group-color',

  QuantityDesignTextColor = 'quantity-design-text-color',

  QuantityDesignButtonColorSolid = 'quantity-design-button-color-solid',
  QuantityDesignButtonColorStartGradient = 'quantity-design-button-color-start-gradient',
  QuantityDesignButtonColorEndGradient = 'quantity-design-button-color-end-gradient',
  QuantityDesignButtonColorGradientDirection = 'quantity-design-button-color-gradient-direction',
  QuantityDesignInputColor = 'quantity-design-input-color',
  QuantityDesignInputColorSolid = 'quantity-design-input-color-solid',
  QuantityDesignInputColorStartGradient = 'quantity-design-input-color-start-gradient',
  QuantityDesignInputColorEndGradient = 'quantity-design-input-color-end-gradient',
  QuantityDesignInputColorGradientDirection = 'quantity-design-input-color-gradient-direction',
  QuantityDesignInputTypography = 'quantity-design-input-typography',
  QuantityDesignLabelTypography = 'quantity-design-label-typography',
  QuantityDesignMargin = 'quantity-design-margin',
  QuantityDesignHoverEffect = 'quantity-design-hover-effect',
  QuantityActionOnIncrease = 'quantity-action-on-increase',
  QuantityActionOnDecrease = 'quantity-action-on-decrease',

  PricingDataSource = 'pricing-data-source',
  PricingDataDownloadLink = 'pricing-data-download-link',
  PricingDataFeatureLabel = 'pricing-data-feature-label',
  PricingDataFeatureValue = 'pricing-data-feature-value',
  PricingDataFeatureType = 'pricing-data-feature-type',
  PricingDataYearlyDiscount = 'pricing-data-yearly-discount',
  PricingDataMonthlyDiscount = 'pricing-data-monthly-discount',
  PricingDataFeaturesSource = 'pricing-data-features-source',

  PricingDataName = 'pricing-data-name',
  PricingDataDescription = 'pricing-data-description',
  PricingDataMonthlyPrice = 'pricing-data-monthly-price',
  PricingDataYearlyPrice = 'pricing-data-yearly-price',
  PricingDataBadgeText = 'pricing-data-badge-text',
  PricingDataButtonText = 'pricing-data-button-text',
  PricingDataPopular = 'pricing-data-popular',
  PricingDataDefault = 'pricing-data-default',

  PricingDesignBackgroundColor = 'pricing-design-background-color',
  PricingDesignCardBackground = 'pricing-design-card-background',
  PricingDesignTextPrimary = 'pricing-design-text-primary',
  PricingDesignTextSecondary = 'pricing-design-text-secondary',
  PricingDesignBorder = 'pricing-design-border',
  PricingDesignHeaderBackground = 'pricing-design-header-background',
  PricingDesignEvenRowBackground = 'pricing-design-even-row-background',
  PricingDesignOddRowBackground = 'pricing-design-odd-row-background',
  PricingDesignFooterBackground = 'pricing-design-footer-background',
  PricingDesignHeaderText = 'pricing-design-header-text',
  PricingDesignPriceText = 'pricing-design-price-text',
  PricingDesignHeaderBorder = 'pricing-design-header-border',
  PricingDesignAccentColor = 'pricing-design-accent-color',
  PricingDesignPopularBadgeBackground = 'pricing-design-popular-badge-background',
  PricingDesignPopularBadgeText = 'pricing-design-popular-badge-text',
  PricingDesignButtonPrimary = 'pricing-design-button-primary',
  PricingDesignButtonPrimaryText = 'pricing-design-button-primary-text',
  PricingDesignButtonSecondary = 'pricing-design-button-secondary',
  PricingDesignButtonSecondaryText = 'pricing-design-button-secondary-text',
  PricingDesignButtonDisabled = 'pricing-design-button-disabled',
  PricingDesignButtonDisabledText = 'pricing-design-button-disabled-text',
  PricingDesignBillingToggleBackground = 'pricing-design-billing-toggle-background',
  PricingDesignBillingToggleActiveBackground = 'pricing-design-billing-toggle-active-background',
  PricingDesignBillingToggleActiveText = 'pricing-design-billing-toggle-active-text',
  PricingDesignBillingToggleInactiveText = 'pricing-design-billing-toggle-inactive-text',
  PricingDesignBillingToggleInactiveHoverText = 'pricing-design-billing-toggle-inactive-hover-text',
  PricingDesignBillingToggleDiscountBackground = 'pricing-design-billing-toggle-discount-background',
  PricingDesignBillingToggleDiscountText = 'pricing-design-billing-toggle-discount-text',
  PricingDesignColumnBackgroundOpacity = 'pricing-design-column-background-opacity',
  PricingDesignLayoutAlignment = 'pricing-design-layout-alignment',
  PricingDesignBillingToggleAlignment = 'pricing-design-billing-toggle-alignment',
  PricingDesignIconSuccess = 'pricing-design-icon-success',
  PricingDesignIconError = 'pricing-design-icon-error',
  PricingDesignGap = 'pricing-design-gap',
  // PricingDesignIconSuccess = 'pricing-design-icon-success',
  // PricingDesignIconError = 'pricing-design-icon-error',
  // PricingDesignIconNeutral = 'pricing-design-icon-neutral',
  PricingDesignWidth = 'pricing-design-width',
  PricingDesignMargin = 'pricing-design-margin',
  PricingDesignLayout = 'pricing-design-layout',
  PricingDesignShowBillingToggle = 'pricing-design-show-billing-toggle',
  PricingDesignShowBadges = 'pricing-design-show-badges',
  PricingDesignShowPopular = 'pricing-design-show-popular',
  PricingDesignShowButton = 'pricing-design-show-button',
  PricingDesignBillingCycle = 'pricing-design-billing-cycle',

  PricingDesignCardBorder = 'pricing-design-card-border',
  PricingDesignCardPopularBorder = 'pricing-design-card-popular-border',
  PricingDesignCardPopularRing = 'pricing-design-card-popular-ring',
  PricingDesignCardTitleText = 'pricing-design-card-title-text',
  PricingDesignCardPriceText = 'pricing-design-card-price-text',
  PricingDesignCardPriceSubtext = 'pricing-design-card-price-subtext',
  PricingDesignCardBadgeBackground = 'pricing-design-card-badge-background',
  PricingDesignCardBadgeText = 'pricing-design-card-badge-text',
  PricingDesignCardButtonPrimary = 'pricing-design-card-button-primary',
  PricingDesignCardButtonPrimaryText = 'pricing-design-card-button-primary-text',
  PricingDesignCardButtonSecondary = 'pricing-design-card-button-secondary',
  PricingDesignCardButtonSecondaryText = 'pricing-design-card-button-secondary-text',
  PricingDesignCardButtonDisabled = 'pricing-design-card-button-disabled',
  PricingDesignCardButtonDisabledText = 'pricing-design-card-button-disabled-text',
  PricingDesignCardButtonBackgroundType = 'pricing-design-card-button-background-type',
  PricingDesignCardBackgroundType = 'pricing-design-card-background-type',
  PricingDesignCardBackgroundSolid = 'pricing-design-card-background-solid',
  PricingDesignCardBackgroundStartGradient = 'pricing-design-card-background-start-gradient',
  PricingDesignCardBackgroundEndGradient = 'pricing-design-card-background-end-gradient',
  PricingDesignCardBackgroundGradientDirection = 'pricing-design-card-background-gradient-direction',
  PricingDesignScheme = 'pricing-design-scheme',
  PricingDesignHoverEffect = 'pricing-design-hover-effect',
  PricingActionOnClickSelectPlan = 'pricing-action-on-click-select-plan',

  NewsletterDataSource = 'newsletter-data-source',
  NewsletterDataCompTitle = 'newsletter-data-comp-title',
  NewsletterDataEmail = 'newsletter-data-email',
  NewsletterDataPlaceholder = 'newsletter-data-placeholder',
  NewsletterDataButtonText = 'newsletter-data-button-text',
  NewsletterDataIcon = 'newsletter-data-icon',
  NewsletterDesignColorGroup = 'newsletter-design-color-group',
  NewsletterDesignButtonColor = 'newsletter-design-button-color',
  NewsletterDesignButtonColorSolid = 'newsletter-design-button-color-solid',
  NewsletterDesignButtonColorStartGradient = 'newsletter-design-button-color-start-gradient',
  NewsletterDesignButtonColorEndGradient = 'newsletter-design-button-color-end-gradient',
  NewsletterDesignButtonColorGradientDirection = 'newsletter-design-button-color-gradient-direction',
  NewsletterDesignBorderColor = 'newsletter-design-border-color',
  NewsletterDesignColorScheme = 'newsletter-design-color-scheme',
  NewsletterDesignCompTitleColorGroup = 'newsletter-design-comp-title-color-group',
  NewsletterDesignCompTitleColor = 'newsletter-design-comp-title-color',
  NewsletterDesignCompTitleColorSolid = 'newsletter-design-comp-title-color-solid',
  NewsletterDesignCompTitleColorStartGradient = 'newsletter-design-comp-title-color-start-gradient',
  NewsletterDesignCompTitleColorEndGradient = 'newsletter-design-comp-title-color-end-gradient',
  NewsletterDesignCompTitleColorGradientDirection = 'newsletter-design-comp-title-color-gradient-direction',
  NewsletterDesignSize = 'newsletter-design-size',
  NewsletterDesignWidth = 'newsletter-design-width',
  NewsletterDesignIconWidth = 'newsletter-design-icon-width',
  NewsletterDesignAlignment = 'newsletter-design-alignment',
  NewsletterDesignCompTitleAlignment = 'newsletter-design-comp-title-alignment',
  NewsletterDesignCompTitleMargin = 'newsletter-design-comp-title-margin',
  NewsletterDesignMargin = 'newsletter-design-margin',
  NewsletterDesignPadding = 'newsletter-design-padding',
  NewsletterDesignTypography = 'newsletter-design-typography',
  NewsletterDesignComponentTitleTypography = 'newsletter-design-component-title-typography',
  NewsletterDesignInputTypography = 'newsletter-design-input-typography',
  NewsletterDesignButtonTypography = 'newsletter-design-button-typography',
  NewsletterDesignHoverEffect = 'newsletter-design-hover-effect',
  NewsletterActionOnClickSubscribe = 'newsletter-action-on-click-subscribe',

  AlertDataTitle = 'alert-data-title',
  AlertDataDescription = 'alert-data-description',
  AlertDataIcon = 'alert-data-icon',
  AlertDesignOutline = 'alert-design-outline',
  AlertDesignElevation = 'alert-design-elevation',
  AlertDesignColorVariant = 'alert-design-color-variant',
  AlertDesignScheme = 'alert-design-scheme',
  AlertDesignWidth = 'alert-design-width',
  AlertDesignAlignment = 'alert-design-alignment',
  AlertDesignMargin = 'alert-design-margin',
  AlertDesignPadding = 'alert-design-padding',
  AlertDesignTypography = 'alert-design-typography',
  AlertDesignTitleTypography = 'alert-design-title-typography',
  AlertDesignDescriptionTypography = 'alert-design-description-typography',
  AlertDesignHoverEffect = 'alert-design-hover-effect',

  IconPickerDataValue = 'icon-picker-data-value',
  IconPickerDataLabel = 'icon-picker-data-label',
  IconPickerDataHelp = 'icon-picker-data-help',
  IconPickerDataDefaultValue = 'icon-picker-data-default-value',
  IconPickerBehaviorRequired = 'icon-picker-behavior-required',

  PhoneInputDataValue = 'phone-input-data-value',
  PhoneInputDataLabel = 'phone-input-data-label',
  PhoneInputDataDefaultValue = 'phone-input-data-default-value',
  PhoneInputBehaviorRequired = 'phone-input-behavior-required',
  PhoneInputBehaviorPattern = 'phone-input-behavior-pattern',
  PhoneInputBehaviorPatternShowHelp = 'phone-input-behavior-pattern-show-help',
  PhoneInputBehaviorMinChar = 'phone-input-behavior-min-char',
  PhoneInputBehaviorMaxChar = 'phone-input-behavior-max-char',
  PhoneInputBehaviorCharacterCounter = 'phone-input-behavior-character-counter',
  PhoneInputDataDefaultValueEditable = 'phone-input-data-default-value-editable',
}

export enum ComponentBehaviorKey {
  Visibility = 'behavior-visibility',
}
